import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { AngularFireStorage } from 'angularfire2/storage';
import { AlertController, DateTime, ToastController } from 'ionic-angular';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import * as firebase from 'firebase';
import { HttpClient, HttpParams } from '@angular/common/http';
import { getCurrencySymbol } from '@angular/common';
import * as moment from 'moment';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';


interface Restaurant {
  tickets: any;
  test: string;
  UID: string;
  braintree_id: any;
  provider: string;
  logo: string;
  logo_share: string;
  image: string;
  company: string;
  fiscal_name: string;
  cif: string;
  currency: string;
  address: string;
  email: string;
  phone: string;
  name: string;
  acces_code: any;
  lat: string;
  lng: string;
  cuisine: string;
  cuisine2: string;
  business: string;
  business2: string;
  tutorial_dashboard: boolean;
  tutorial_addons: boolean;
  tutorial_dish: boolean;
  tutorial_menu: boolean;
  tutorial_tpv: boolean;
  tutorial_ingredient: boolean;
  tutorial_product: boolean;
  tutorial_reservation: boolean;
  tutorial_stock: boolean;
  tutorial_inexp: boolean;
  tutorial_order: boolean;
  tutorial_kitchen: boolean;
  tutorial_configuration: boolean;
  lang: string;
  alert_message: string;
  alert_style: string;
  pro: boolean;
  covermanager_api: string,
  covermanager_rest_name: string,
  covermanager: boolean;
  stripe_customer: string;
  starprnt: boolean;
  starprnt_portName: string;
  starprnt_cashdrawer: boolean;
  printer_type: string;
  printer_size: string;
  printer_cashdrawer: boolean;
  ordatic: boolean;
  static_wait: boolean;
  tips: boolean;
  tip_1: number;
  tip_2: number;
  tip_3: number;
  format_time: string,
  format_date: string,
  alegra_electronic_invoice: boolean;
  alegra_email: string,
  alegra_token: string,
  address_city: string,
  address_country: string,
  address_countrycode: string,
  address_countrystate: string,
  address_neighborhood: string,
  address_province: string,
  address_state: string,
  address_zipcode: string,
  reservations_web: boolean,
  web_table: boolean,
  web_delivery: boolean,
  web_pickup: boolean,
  web_schedule: any,
  facturacion_id: string,
  web_sending_price: number,
  web_free_sending: number,
  web_aprox_delivery_time: string,
  web_tk_min_order: number,
  web_offer: number,
  web_amount_to_offer: number,
  orders_persons_elements: boolean,
  web_schedule_monday: any,
  web_schedule_tuesday: any,
  web_schedule_wednesday: any,
  web_schedule_thursday: any,
  web_schedule_friday: any,
  web_schedule_saturday: any,
  web_schedule_sunday: any,
  logo_base64: string;
  web_title_principal: string;
  web_title_secondary: string;
  web_text_title_aboutus: string;
  web_text_large_aboutus: string;
  web_img1_aboutus: string;
  web_img2_aboutus: string;
  web_img3_aboutus: string;
  web_facebook: string;
  web_whatsapp: string;
  web_instagram: string;
  web_twitter: string;
  web_tripadvisor: string;
  web_pinterest: string;
  web_linkedin: string;
  web_tiktok: string;
  addon_user_arrival: boolean;
  print_auto_sunmi: boolean;
  web_tk_open_hour: any;
  web_tk_close_hour: any;
  interval_between_orders: any;
  number_orders: any;
  web_tk_horary: boolean;
  web_tk_active: boolean;
  web_tk_select_date: boolean;
  sherlock_campaign: string;
  sherlock_browser: string;
  sherlock_ip: string;
  sherlock_origin: string;
  sherlock_os_platform: string;
  sherlock_web: string;
  buyer_person: string;
  deliverect: boolean;
  deliverect_order_autoaccept: boolean;
  analytics_dashboard: any;
  payment_method_stripe: boolean;
  payment_method_stripe_details_submitted: boolean;
  connected_acount: string;
  connected_acount_old: boolean;
  payment_method_paypal: boolean;
  payment_method_paypal_client_id: string;
  payment_method_payplaza: boolean;
  payment_method_verifone: boolean;
  payment_method_crypto: boolean;
  payment_method_redsys: boolean;
  payment_method_redsys_offline: boolean;
  payment_method_redsys_bizum: boolean;
  payment_method_redsys_merchant_code: string;
  payment_method_redsys_merchant_signature: string;
  payment_method_redsys_terminal: string;
  payment_method_redsys_currency: string;
  payment_method_on_delivery: boolean;
  payment_method_email: boolean;
  payment_method_crypto_api: string;
  payment_method_crypto_webhook: string;
  license: string;
  privacy_policy: string;
  analytics_m2_active: number;
  analytics_occupancy_persons: number;
  pudu_robots_ip_sdk: string;
  pudu_robots_port_sdk: string;
  pudu_robots_sdk_device_name: string;
  pudu_robots_sdk_device_id: string;
  pudu_robots_sdk_device_secret: string;
  pudu_robots_sdk_region: string;
  pudu_robots_service_up: boolean;
  pudu_robots_integration: boolean;
  reservation_text_web: string;
  pro_trial_date: any;
  octupus_cartamenu_list: boolean;
  plg_cartamenu_starter: boolean;
  plg_cartamenu_finisher: boolean;
  plg_cartamenu_winner: boolean;
  register_start_by: string;
  plg_register_stores: string;
  plg_register_workers: string;
  plg_register_new_business: string;
  plg_register_is_digital: string;
  plg_reservas_starter: boolean;
  plg_reservas_finisher: boolean;
  plg_reservas_winner: boolean;
  plg_articles_starter: boolean;
  plg_articles_finisher: boolean;
  plg_articles_winner: boolean;
  plg_pedidos_finisher: boolean;
  plg_pos_finisher: boolean;
  plg_pos_starter: boolean;
  plg_pos_winner: boolean;
  plg_orders_finisher: boolean;
  plg_orders_starter: boolean;
  plg_kds_finisher: boolean;
  plg_kds_starter: boolean;
  plg_stock_starter: boolean;
  plg_stock_finisher: boolean;
  plg_stock_winner: boolean;
  plg_pedidos_starter: boolean;
  plg_pedidos_winner: boolean;
  octupus_reservas_list: boolean;
  reservation_in_share: boolean;
  email_reservations: string;
  email_takeaway: string;
  email_ratings: string;
  email_general: string;
  email_general_active: boolean;
  register_step: string;
  tax_name: string;
  timezone: string;
  web_cupons: any;
  web_soon_as_possible: boolean;
  stripe_customer_id: string;
  access_pos: boolean;
  rating_autor_sender: boolean;
  email_not_new_tk_order: boolean;
  email_not_new_reservation: boolean;
  email_not_new_valoration: boolean;
  payment_method_bank_transfer: boolean;
  payment_method_american_express: boolean;
  payment_method_bizum: boolean;
  payment_method_online: boolean;
  payment_method_bank_draft: boolean;
  payment_method_cryptocurrencies: boolean;
  payment_method_ticket_restaurant: boolean;
  payment_not_specified: boolean;
  payment_method_redsys_top: boolean;
  payment_method_redsys_top_user_id: number;
  payment_method_redsys_top_user_token: string;
  payment_method_redsys_top_client_id: string;
  payment_method_redsys_top_merchant_id: number;
  payment_method_comerciaglobalpay_top: boolean;
  payment_method_comerciaglobalpay_top_merchant_id: string;
  payment_method_comerciaglobalpay_top_terminal_id: string;
  payment_method_comerciaglobalpay_top_activation_code: string;
  uber_direct_customer_id: string;
  uber_direct_client_id: string;
  uber_direct_client_secret: string;
  uber_direct_active: boolean;
  images_second_display: any;
  iban_number: string;
  social_links: { selectedSocial: string; socialLink: string }[];
  primary_color: any;
  secondary_color: any;
  erpnext_last_update_customer: any;
  glovo: boolean;
  glovo_store_id: string;
  glovo_menu_uploaded: boolean;
  glovo_upload_menu_transaction_id: string;
  glovo_upload_items_transaction_id: string;
  web_tk_bag?: boolean;
  web_tk_bag_price?: number;
}

interface Dish {
  UID: string;
  UID_RESTAURANT: string;
  name_es: string;
  allergens: object;
  recipe: string;
  tools: string;
  price: number;
  image: string;
  tags: object;
  time: string;
  foodcost: object;
  foodcost_parts: string;
  created_at: string;
  updated_at: string;
  price_half: number;
  price_tapa: number;
  name_ca: string;
  name_de: string;
  name_en: string;
  name_fr: string;
  name_it: string;
  foodcost_static: number;
}

interface Ingredient {
  UID: string;
  UID_RESTAURANT: string;
  allergens: object;
  measurement: string;
  name: string;
  price_static: number;
  provider_static: string;
  providers: object;
  stock: number;
  stock_alert: number;
  sub_recipe: boolean;
  tags: object;
  tags_static: string;
  tax: number;
  foodcost: object;
  real_weight: number;
  recipe: string;
  time: string;
  tools: string;
  image: string;
}

interface Product {
  UID: string;
  UID_RESTAURANT: string;
  allergens: object;
  measurement: string;
  name: string;
  price_static: number;
  provider_static: string;
  providers: object;
  stock: number;
  stock_alert: number;
  sub_recipe: boolean;
  tags: object;
  tags_static: string;
  tax: number;
  foodcost: object;
  real_weight: number;
  recipe: string;
  time: string;
  tools: string;
  image: string;
  pvp: number;
  pvp2: number;
  pvp3: number;
}

interface School {
  UID: string;
  email: string;
  name: string;
  created_at: DateTime;
  updated_at: DateTime;
}

interface ExtrasFooter {
  cafe_no: boolean;
  cafe_si: boolean;
  pan_vino_agua_no: boolean;
  pan_vino_agua_si: boolean;
  refresco_no: boolean;
  refresco_si: boolean;
}

interface Menu {
  UID: string;
  UID_RESTAURANT: string;
  caption_show: boolean;
  section_show: false,
  enumerate: boolean;
  extra: number;
  extras_footer: ExtrasFooter;
  footer: string;
  logo_show: boolean;
  price: number;
  reference: string;
  sections: object;
  extras_section: object,
  separator: string;
  style: string;
  subtitle_ca: string;
  subtitle_de: string;
  subtitle_en: string;
  subtitle_es: string;
  subtitle_fr: string;
  subtitle_it: string;
  template: string;
  title_ca: string;
  title_de: string;
  title_en: string;
  title_es: string;
  title_fr: string;
  title_it: string;
  header_font_family: string;
  header_font_size: string;
  header_font_color: string;
  header_text_align: string;
  footer_font_family: string;
  footer_font_size: string;
  footer_font_color: string;
  footer_text_align: string;
  tpv_active: boolean;
  pos_favourite: boolean;
  digital_app: boolean;
  template_name: string;
  tags: object;
  tags_static: object;
}

export type Unit = "kg" | "g" | "l" | "ml";
export interface ConvertedQuantity {
  value: number;
  unit: Unit;
}

@Injectable()
export class Globals {
  public restaurant_uid: string = 'test_rest';
  public RESTAURANT_TAX: number = 10;
  public no_provider: any;
  public user_name: any = '';
  public user_email: any = '';
  public user_rol: any = '';
  public user_access: any = '';
  public user_type: any = '';
  public user_tax_name: any = 'IVA';
  public user_tax: any = 21;
  public user_timezone: any = 'Europe/Madrid';
  public user_currency: any = 'EUR';
  public user_exp_dashboard: any = false; //True poca info | False molta info
  public firestore;
  public logo_url: Observable<string | null>;
  public logo_share_url: Observable<string | null>;
  public dish_image_url: Observable<string | null>;
  public rest_image_url: Observable<string | null>;
  public token_id: any;
  public waiter: any;
  public waiter_uid: any;
  public side_menu_active: string = 'home';
  public side_menu_active_analytics: boolean = false;
  public side_menu_config_active: string = '';
  public users_array = [];
  public rests_user = [];
  public users: any;
  public currency_symbol: any;
  public tags_dishs = [];
  public tags_ingredients = [];
  public tags_products = [];
  public tags_combo = [];
  public tags_all = [];
  public weather: any;
  public print_content: any;
  public cart_elements: any = 0;
  public user_uid: any;
  public user_uid_auth: any;
  public analytics_finish_date: any = moment().format("YYYY-MM-DD");
  public analytics_start_date: any = this.getLastDays(this.analytics_finish_date, 3 - 1);
  public web_aboutus_url1: Observable<string | null>;
  public web_aboutus_url2: Observable<string | null>;
  public web_aboutus_url3: Observable<string | null>;
  public domini_sites: string = '';
  //
  public register_address: string = '';
  public register_phone: string = '';
  public register_company: string = '';
  public register_contact: string = '';
  public register_business: string = '';
  public register_stores: string = '';
  public register_workers: string = '';
  public register_new_business: string = '';
  public register_worked_so_far: string = '';
  public register_buyer_person: string = '';
  public register_start_by: string = '';
  //
  public school_uid: string = '';

  public platform_mobile = false; //Es para saber si es un movil o iphone
  public so_mobile = false; //Android / iOS
  public android = false;
  public ios = false;
  public browser_name: any;
  public so_name = 'web';
  public platform_name = 'core';
  public platform_width = 'desktop';
  //Tour
  public tour = '';
  public tour_step_user = -1;
  public currency_lang = 'es';
  public connection: boolean = true;
  public connection_manual: boolean = false;

  public device_model: string = '';
  public device_manufacturer: string = '';

  public api_path: any = 'https://api.mycheftool.com/api/';
  //public api_path: any = 'https://apitest.mycheftool.com/api/';
  //public api_path: any = 'http://127.0.0.1:8000/';

  public proxy_path: any = 'https://resources.mycheftool.com/html2canvas-proxy/proxy.php';
  public api_sg_path: any = 'https://api.softwaregirona.com/';
  public braintree_domain = 'softwaregirona.com';
  public merchantAccount = 'infosoftwaregironacom';
  public app_version = 'v3.124.4';
  public stripe_key = 'pk_live_OhiZWsqwX7Apm0SiJltikyZp';
  public analytics_path = 'https://data.mycheftool.com/';
  //public analytics_path = 'https://datadebug.mycheftool.com/';
  //public analytics_path = 'http://localhost:3000/';

  public mctpay_path = 'https://pay.mycheftool.com/';

  public api_gestio_path: any = 'https://gestio.mycheftool.com/api/';
  //public api_gestio_path: any = 'http://localhost/gestio-mycheftool/api/';

  public share_path: any = 'https://share.mycheftool.com/';

  public ads_show: boolean = false; //Mostrar o no ads

  public user_disable: any;
  public user_is_pro_trial: boolean = false;

  //
  sunmi_printers = [
    {
      name: 'V2_PRO',
      size: '58',
    },
    {
      name: 'P2_PRO',
      size: '58',
    },
    {
      name: 'T2',
      size: '80',
    }
  ];
  //notifications
  public token_current_user: string;
  public token_user_uid: string;
  toast_notifications: boolean = false;
  //
  mobile_is_room: boolean = true;
  //
  table_paid_alert: boolean = false;
  //
  open_side_menu: boolean = false;
  menu_active: string = 'main';
  arrosseria_uid = 'VJGDPqdNWBqFaY5KibsN';
  trial_days: any = 0;
  public public_key: string = '';

  //tracking
  public tracking_exp = {
    'create_element': 5,  //crear plato/producto
    'insert_element_menu': 1, //insertar plato/producto a carta/menu/combo
    'create_section': 10, //crear seccion en carta/combo/menu
    'create_new_menu': 50,  //crear carta/menu/combo
    'share': 20,  //compartir carta/menu/combo
    'create_qr': 200, //crear qr al share desde carta/menu/combo
    'print_element': 200,  //imprimir carta/menu/combo
    'starter': 0,  //començar a crear
    'finisher': 0,  //acabar de crear
    'create_reservation_manual': 1, //crear reserva
    'create_article': 1, //crear article
    'update_article': 1, //modificar article
    'delete_article': 1, //eliminar article
    'pay_config': 100, //configurar pago de pay
    'create_ingredient': 10, //Crear ingrediente
    'delete_ingredient': 10, //Eliminar ingrediente
    'modify_stock': 10, //Modificar stock
    'create_delivery_note': 100, //Crear albaran
    'provider_order': 100, //Enviar pedido a proveedor
    'deduct_stock': 1 //Deduct stock
  };

  public objectToArray(object) {
    var _return = Object.keys(object).map(function (index) {
      let _array = object[index];
      return _array;
    });
    return _return;
  }

  constructor(public afs: AngularFirestore,
    public storage: AngularFireStorage,
    private http: HttpClient,
    private datePipe: DatePipe,
    public translate: TranslateService,
    private datepipe: DatePipe,
    private toastCtrl: ToastController,
    public alertCtrl: AlertController) {
    this.firestore = firebase.firestore();
  }

  restaurantsCol: AngularFirestoreCollection<Restaurant>;
  restaurantCol: AngularFirestoreCollection<Restaurant>;
  restaurants: Observable<Restaurant[]>;
  restaurantDoc: AngularFirestoreDocument<Restaurant>;
  restaurant: Restaurant;


  async getRestaurant(UID_RESTAURANT) {
    // Validate that UID_RESTAURANT is not empty
    if (!UID_RESTAURANT || UID_RESTAURANT.trim() === '') {
      console.error('getRestaurant: UID_RESTAURANT is empty or undefined');
      return;
    }

    const restRef = this.firestore.collection('restaurants').doc(UID_RESTAURANT);

    await restRef.get().then(async doc => {
      var _rest = doc.data();
      this.restaurant = _rest as Restaurant;
      if (this.restaurant != undefined) {

        //get public key or dominis
        await this.getPublicKeyDominiSites();
        //if restaurant have license pro_trial, check days left of trial and change license
        if (this.restaurant.license == 'pro_trial') {
          this.user_is_pro_trial = true;
          this.getTrialDays();
          this.restaurant.license = 'pro';
        } else if (this.restaurant.license == 'unsuscribed') {
          this.restaurant.license = 'free';
        }
        //save in globals in restaurant values
        if (this.restaurant.logo)
          this.getLogoImageUrl(this.restaurant.logo, 'print');
        if (this.restaurant.logo_share)
          this.getLogoImageUrl(this.restaurant.logo_share, 'share');

        if (this.restaurant.image)
          this.getRestImageUrl(this.restaurant.image);

        if (!this.restaurant.printer_type) {
          this.restaurant.printer_type = 'native';
        }

        //save ing globals setup initial values
        var str = _rest.currency;
        this.user_currency = str.substring(str.lastIndexOf("(") + 1,
          str.lastIndexOf(")"));
        //
        this.user_tax_name = _rest.tax_name;
        this.user_tax = _rest.tax_percentage;
        this.user_timezone = _rest.timezone;

        this.RESTAURANT_TAX = _rest.tax_percentage;

        this.register_stores = _rest.plg_register_stores;
        this.register_workers = _rest.plg_register_workers;
        this.register_new_business = _rest.plg_register_new_business;
        this.register_worked_so_far = _rest.plg_register_is_digital;
        this.register_start_by = _rest.register_start_by;

        // Cargar tags al inicio (consulta única, sin suscripciones)
        this.getAllTags(UID_RESTAURANT);
      }
    });

    this.currency_symbol = getCurrencySymbol(this.user_currency, 'narrow', 'es');
  }

  school: School;

  async getSchool(UID_SCHOOL) {
    // Validate that UID_SCHOOL is not empty
    if (!UID_SCHOOL || UID_SCHOOL.trim() === '') {
      console.error('getSchool: UID_SCHOOL is empty or undefined');
      return;
    }

    const schRef = this.firestore.collection('schools').doc(UID_SCHOOL);

    await schRef.get().then(doc => {
      var _school = doc.data();
      this.school = _school as School;
    });
  }

  async getAccessCodes() {

    const ordersRef = this.firestore.collection('users');

    var users = [];

    await ordersRef.get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          var user = doc.data();
          user.UID = doc.id;
          users.push(user);
        });
      });

    return users
  }

  async getUsers() {
    this.users_array = [];
    var users = await this.getAccessCodes();
    for (let user of users) {
      for (let restaurant of this.objectToArray(user.restaurants)) {
        if (restaurant.UID_RESTAURANT == this.restaurant_uid) {
          this.users_array.push({
            uid: user.UID,
            name: user.name,
            email: user.email,
            rol: restaurant.rol,
            uid_auth: user.uid_user_auth
          });
        }
      }
    }
  }

  async getUsersFromNode() {
    this.users_array = [];
    //get users from node
    const params = new HttpParams()
      .set('public_key', this.public_key);
    await this.http.post(this.analytics_path + 'users/get_users_v2', params, {})
      .subscribe(async res => {
        var users = res['users'];
        //
        for (let user of users) {
          for (let restaurant of this.objectToArray(user.restaurants)) {
            //push solo si es restaurante del login
            if (restaurant.UID_RESTAURANT === this.restaurant_uid) {
              //push
              this.users_array.push({
                uid: user.UID,
                name: user.name,
                email: user.email,
                rol: restaurant.rol,
                uid_auth: user.uid_user_auth,
                disable: restaurant.disable || false,
                access: restaurant.access
              });
            }
          }
        }
        this.users = this.users_array;
      });
  }

  public getListRestaurants() {
    this.restaurantsCol = this.afs.collection('restaurants');
    this.restaurants = this.restaurantsCol.snapshotChanges().map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as Restaurant;
        data.UID = a.payload.doc.id;
        return data;
      });
    });
  }

  public async getMultiRestaurants() {
    var restaurants = [];
    for (let uid of this.rests_user) {
      if (!uid[0] || uid[0].trim() === '') {
        console.error('getMultiRestaurants: UID is empty or undefined');
        continue;
      }
      const restRef = this.firestore.collection('restaurants').doc(uid[0]);

      var _rest;

      await restRef.get().then(doc => {
        _rest = doc.data();
        _rest.UID = doc.id;
        _rest.user_rol = uid[1];
        _rest.user_name_defwaiter = uid[2];
        _rest.user_uid_defwaiter = uid[3];
        if (_rest.logo) {
          _rest.logo_url = "https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/" + _rest.logo.replace('/', '%2F') + "?alt=media";
        }
        restaurants.push(_rest);
      });
    }
    return restaurants;
  }

  public getLogoImageUrl(image_ref, type) {
    //Get image url for show. Lo utilitzamos en las classes de las views para utlitzarlas al momento ya que la funcion no tiene await.
    const ref = this.storage.ref(image_ref);
    if (type === 'share') {
      this.logo_share_url = ref.getDownloadURL();
    } else {
      this.logo_url = ref.getDownloadURL();
    }

    var logo = image_ref;
    let img = document.createElement("img");
    img.src = "https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/logo%2F" + logo.substr(5) + "?alt=media";
  }

  public getRestImageUrl(image_ref) {
    //Get image url for show. Lo utilitzamos en las classes de las views para utlitzarlas al momento ya que la funcion no tiene await.
    const ref = this.storage.ref(image_ref);
    this.rest_image_url = ref.getDownloadURL();
  }

  async getRestaurantAsync(uid) {
    // Validate that uid is not empty
    if (!uid || uid.trim() === '') {
      console.error('getRestaurantAsync: uid is empty or undefined');
      return;
    }

    const restRef = this.firestore.collection('restaurants').doc(uid);

    var _rest;

    await restRef.get().then(doc => {
      _rest = doc.data();
    });

    return _rest

  }

  public GAtrackView(ga_category: string, ga_page: string, user_id: string, type: string, page: string, category: string, extra) {
    //type View Create/Update Delete Login Logout
    //page list view
    //category sections
    //extra
    //setLog
    //this.globals.GAtrackView('Addons', 'Addons - View '+ this.addon_id, this.globals.restaurant.email);
    this.dataSetLog(type, category, page, this.user_email, this.user_rol, extra);


    //this.mixPanelTrack(page, user_id);

  }

  public mixPanelTrack(page: string, user_id: string) {
    /*this.mixpanel.init('c363d43aee31d4bcf7935a369db16d20');
    this.mixpanel.identify(user_id);
    this.mixpanel.track(page);*/
  }

  public AdressApi(address, uid, location) {
    //Send address to api and response de Geolocation.
    if (this.restaurant.lat == undefined && this.restaurant.address == undefined) { //Comprovamos si tiene localizacion para no buscarla siempre
      const params = new HttpParams()
        .set('address', address);
      this.http.post(this.api_path + 'geo', params, {})
        .subscribe(res => {

          this.GeoSaveRest(res['lat'], res['lng'], uid);
        });
    } else {
      if (location == 'conf') {
        const params = new HttpParams()
          .set('address', address);
        this.http.post(this.api_path + 'geo', params, {})
          .subscribe(res => {
            this.GeoSaveRest(res['lat'], res['lng'], uid);
          });
      }
    }


  }

  public GeoSaveRest(lat, lng, uid) {
    // Validate that uid is not empty
    if (!uid || uid.trim() === '') {
      console.error('GeoSaveRest: uid is empty or undefined');
      return;
    }

    this.afs.collection('restaurants').doc(uid).update({
      'lat': lat,
      'lng': lng,
    }).then(() => {
      this.restaurant.lat = lat;
      this.restaurant.lng = lng;
    });
  }

  public dataSet(name, value, value_id, extra, test = 'false') {
    const params = new HttpParams()
      .set('name', name)
      .set('domini', this.restaurant_uid)
      .set('tipo1', this.restaurant.cuisine)
      .set('tipo2', this.restaurant.cuisine2)
      .set('tipo3', null)
      .set('lat', this.restaurant.lat)
      .set('long', this.restaurant.lng)
      .set('value', value)
      .set('value_id', value_id)
      .set('extra', extra)
      .set('test', test)
      .set('business1', this.restaurant.business)
      .set('business2', this.restaurant.business2);

    this.http.post(this.analytics_path + 'data', params, {})
      .subscribe();
    const _extra = {
      name: name,
      value: value,
      value_id: value_id,
      extra: extra,
      test: test
    };
    this.sendDataToDataCollection('data_set', _extra);
  }

  public dataSetLog(type, category, page, user, rol, extra) {
    const params = new HttpParams()
      .set('category', category)
      .set('domini', this.restaurant_uid)
      .set('extra', extra)
      .set('page', page)
      .set('restaurant', this.restaurant.company)
      .set('rol', rol)
      .set('type', type)
      .set('user', user)
      .set('tipo1', this.restaurant.cuisine)
      .set('tipo2', this.restaurant.cuisine2)
      .set('lat', this.restaurant.lat)
      .set('long', this.restaurant.lng)
      .set('business1', this.restaurant.business)
      .set('business2', this.restaurant.business2)
      .set('provider', this.restaurant.provider)
      .set('platform_name', this.platform_name)
      .set('so_name', this.so_name);

    this.http.post(this.analytics_path + 'log', params, {})
      .subscribe();
    const _extra = {
      category: category,
      page: page,
      rol: rol,
      extra: extra,
      type: type,
      user: user,
    };
    this.sendDataToDataCollection('log_set', _extra);
  }

  public dateTimeNow() {
    // Parse our locale string to [date, time]
    var date = new Date().toLocaleString().split(" ");

    // Now we can access our time at date[1], and monthdayyear @ date[0]
    var time = date[1];
    var mdy = date[0];

    // We then parse  the mdy into parts
    var mdya = mdy.split('/');
    var month = parseInt(mdya[0]);
    var day = parseInt(mdya[1]);
    var year = parseInt(mdya[2]);

    // Putting it all together
    var formattedDate = year + '-' + day + '-' + month + ' ' + time;
    return formattedDate;
  }

  public createDateTimeNow() {
    // Parse our locale string to [date, time]
    var date = new Date().toLocaleString().split(" ");

    // Now we can access our time at date[1], and monthdayyear @ date[0]
    var time = date[1];
    var mdy = date[0];

    // We then parse  the mdy into parts
    var mdya = mdy.split('/');
    var month = parseInt(mdya[0]);
    var day = parseInt(mdya[1]);
    var year = parseInt(mdya[2]);

    // Putting it all together
    var formattedDate = year + '-' + String("00" + month).slice(-2) + '-' + String("00" + day).slice(-2) + ' ' + time;
    return formattedDate;
  }

  async checkBarTable() {
    var bar = await this.tablesCheckBarExist(this.restaurant_uid);//buscar bar si existe
    if (bar == false) {
      this.createTableBar();
    }
  }


  async tablesCheckBarExist(UID_RESTAURANT) {
    var bar_exist = false;
    const providersRef = this.firestore.collection('tables');

    await providersRef.where('UID_RESTAURANT', '==', UID_RESTAURANT).get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          var table = doc.data();
          if (table.type == 'bar') {
            bar_exist = true;
          }
        });
      });

    return bar_exist;
  }

  async createTableBar() {
    var cashs = await this.getCashFirst(this.restaurant_uid);

    await this.afs.collection('tables').add({
      'UID_RESTAURANT': this.restaurant_uid,
      'name': 'bar',
      'type': 'bar',
      'customer': {},
      'ticket': {
        'amount': 0,
        'date': '',
        'list': {},
        'number': '',
        'payment': false,
        'payment_type': '',
        'waiter': '',
        'waiter_uid': '',
        'tip': 0
      },
      'cash_static': cashs.name,
      'cash_uid': cashs.UID,
      'order': 0,
    })
  }

  async getCashFirst(UID_RESTAURANT) {
    const variationsRef = this.firestore.collection('cashs');

    var cashs = [];

    await variationsRef.where('UID_RESTAURANT', '==', UID_RESTAURANT)
      .get()
      .then(snapshot => {
        snapshot.forEach(doc => {

          var cash = doc.data();
          cash.UID = doc.id;

          cashs.push(cash);
        });
      });

    return cashs[0]
  }

  cleanDuplicates(arr) {
    var unique = arr.filter(function (elem, index, self) {
      return index === self.indexOf(elem);
    });
    return unique;
  }


  //Recupera todos los tags (consultas únicas, sin suscripciones)
  async getAllTags(uid_restaurant) {
    //dish products (tags_all)
    await this.getDishProductTags(uid_restaurant);
    //dishes (tags_dishs)
    await this.getDishTags(uid_restaurant);
    //ingredients (tags_ingredients)
    await this.getIngredientsTags(uid_restaurant);
    //products (tags_products)
    await this.getProductsTags(uid_restaurant);
    //combos (tags_combo)
    await this.getComboTags(uid_restaurant);
  }

  //recupera los tags de platos y productos (consulta única, sin suscripciones)
  async getDishProductTags(uid_restaurant) {
    var tags_all = [
      this.translate.instant('general-arroces'),
      this.translate.instant('general-bocadillos'),
      this.translate.instant('general-carnes'),
      this.translate.instant('general-ensaladas'),
      this.translate.instant('general-entrantes'),
      this.translate.instant('general-hamburguesas'),
      this.translate.instant('general-mariscos'),
      this.translate.instant('general-pastas'),
      this.translate.instant('general-pescados'),
      this.translate.instant('general-pizzas'),
      this.translate.instant('general-postres'),
      this.translate.instant('general-primeros'),
      this.translate.instant('general-segundos'),
      this.translate.instant('general-sopas'),
      this.translate.instant('general-sugerencias'),
      this.translate.instant('general-tacos'),
      this.translate.instant('general-tapas'),
      this.translate.instant('general-bolleria'),
      this.translate.instant('general-zumos'),
      this.translate.instant('general-frutos-secos'),
      this.translate.instant('general-salsas'),
      this.translate.instant('general-aceites-vinagres'),
      this.translate.instant('general-chocolates'),
      this.translate.instant('general-cafes'),
      this.translate.instant('general-cervezas'),
      this.translate.instant('general-combinados'),
      this.translate.instant('general-chupitos'),
      this.translate.instant('general-helados'),
      this.translate.instant('general-infusiones-te'),
      this.translate.instant('general-patatas-snacks'),
      this.translate.instant('general-batidos'),
      this.translate.instant('general-conservas'),
      this.translate.instant('general-aperitivos'),
      this.translate.instant('general-golosinas'),
      this.translate.instant('general-vinos'),
      this.translate.instant('general-licores'),
      this.translate.instant('general-aguas'),
      this.translate.instant('general-bebidas'),
      this.translate.instant('general-cocktails'),
    ];

    //dishes - consulta única
    try {
      const dishesSnapshot = await this.firestore.collection('dish')
        .where('UID_RESTAURANT', '==', uid_restaurant)
        .get();

      dishesSnapshot.forEach(doc => {
        const data = doc.data() as Dish;
        if (data.tags) {
          tags_all = tags_all.concat(this.objectToArray(data.tags));
        }
      });
    } catch (error) {
      console.error('Error loading dish tags:', error);
    }

    //products - consulta única
    try {
      const productsSnapshot = await this.firestore.collection('products')
        .where('UID_RESTAURANT', '==', uid_restaurant)
        .get();

      productsSnapshot.forEach(doc => {
        const data = doc.data() as Product;
        if (data.tags) {
          tags_all = tags_all.concat(this.objectToArray(data.tags));
        }
      });
    } catch (error) {
      console.error('Error loading product tags:', error);
    }

    //caso primera vez cuando no hay elementos que tengan tags
    this.tags_all = this.cleanDuplicates(tags_all);
    this.tags_all.sort((one, two) => (one.toLowerCase() < two.toLowerCase() ? -1 : 1));
  }

  // Añadir tags al array global cuando se crean/editan artículos
  addTagsToGlobal(tags: string[]) {
    if (!tags || tags.length === 0) {
      return;
    }

    let hasNewTags = false;

    tags.forEach(tag => {
      if (tag && tag !== 'eti' && this.tags_all.indexOf(tag) === -1) {
        this.tags_all.push(tag);
        hasNewTags = true;
      }
    });

    if (hasNewTags) {
      this.tags_all = this.cleanDuplicates(this.tags_all);
      this.tags_all.sort((one, two) => (one.toLowerCase() < two.toLowerCase() ? -1 : 1));
    }
  }

  //recupera los tags de platos
  //recupera los tags de platos (consulta única, sin suscripciones)
  async getDishTags(uid_restaurant) {
    var tags_dish = [
      this.translate.instant('general-arroces'),
      this.translate.instant('general-bocadillos'),
      this.translate.instant('general-carnes'),
      this.translate.instant('general-ensaladas'),
      this.translate.instant('general-entrantes'),
      this.translate.instant('general-hamburguesas'),
      this.translate.instant('general-mariscos'),
      this.translate.instant('general-pastas'),
      this.translate.instant('general-pescados'),
      this.translate.instant('general-pizzas'),
      this.translate.instant('general-postres'),
      this.translate.instant('general-primeros'),
      this.translate.instant('general-segundos'),
      this.translate.instant('general-sopas'),
      this.translate.instant('general-sugerencias'),
      this.translate.instant('general-tacos'),
      this.translate.instant('general-tapas')];

    //dishes - consulta única
    try {
      const dishesSnapshot = await this.firestore.collection('dish')
        .where('UID_RESTAURANT', '==', uid_restaurant)
        .get();

      dishesSnapshot.forEach(doc => {
        const data = doc.data() as Dish;
        if (data.tags) {
          tags_dish = tags_dish.concat(this.objectToArray(data.tags));
        }
      });
    } catch (error) {
      console.error('Error loading dish tags:', error);
    }

    //caso primera vez cuando no hay elementos que tengan tags
    this.tags_dishs = this.cleanDuplicates(tags_dish);
    this.tags_dishs.sort((one, two) => (one.toLowerCase() < two.toLowerCase() ? -1 : 1));
  }

  //recupera los tags de ingredientes (consulta única, sin suscripciones)
  async getIngredientsTags(uid_restaurant) {
    var tags_ingredients = [
      this.translate.instant('general-carnes'),
      this.translate.instant('general-pescados'),
      this.translate.instant('general-lacteos'),
      this.translate.instant('general-salsas'),
      this.translate.instant('general-embutidos'),
      this.translate.instant('general-especies'),
      this.translate.instant('general-frutos-secos'),
      this.translate.instant('general-chips-snacks'),
      this.translate.instant('general-chocolates'),
      this.translate.instant('general-helados'),
      this.translate.instant('general-reposteria'),
      this.translate.instant('general-hortalizas'),
      this.translate.instant('general-fruta'),
      this.translate.instant('general-elaborados'),
      this.translate.instant('general-semielaborados'),
      this.translate.instant('general-bebidas-vegetales'),
      this.translate.instant('general-sin-gluten'),
      this.translate.instant('general-sin-lactosa'),
      this.translate.instant('general-postres'),
      this.translate.instant('general-cafes'),
      this.translate.instant('general-aceites-vinagres'),
      this.translate.instant('general-conservas'),
      this.translate.instant('general-verduras'),
      this.translate.instant('general-harinas'),
      this.translate.instant('general-ovoproductos')];

    //ingredients - consulta única
    try {
      const ingredientsSnapshot = await this.firestore.collection('ingredients')
        .where('UID_RESTAURANT', '==', uid_restaurant)
        .get();

      ingredientsSnapshot.forEach(doc => {
        const data = doc.data() as Ingredient;
        if (data.tags) {
          tags_ingredients = tags_ingredients.concat(this.objectToArray(data.tags));
        }
      });
    } catch (error) {
      console.error('Error loading ingredients tags:', error);
    }

    //caso primera vez cuando no hay elementos que tengan tags
    this.tags_ingredients = this.cleanDuplicates(tags_ingredients);
    this.tags_ingredients.sort((one, two) => (one.toLowerCase() < two.toLowerCase() ? -1 : 1));
  }

  //recupera los tags de productos (consulta única, sin suscripciones)
  async getProductsTags(uid_restaurant) {
    var tags_products = [
      this.translate.instant('general-bolleria'),
      this.translate.instant('general-zumos'),
      this.translate.instant('general-frutos-secos'),
      this.translate.instant('general-salsas'),
      this.translate.instant('general-aceites-vinagres'),
      this.translate.instant('general-chocolates'),
      this.translate.instant('general-cafes'),
      this.translate.instant('general-cervezas'),
      this.translate.instant('general-combinados'),
      this.translate.instant('general-chupitos'),
      this.translate.instant('general-helados'),
      this.translate.instant('general-infusiones-te'),
      this.translate.instant('general-patatas-snacks'),
      this.translate.instant('general-batidos'),
      this.translate.instant('general-conservas'),
      this.translate.instant('general-aperitivos'),
      this.translate.instant('general-golosinas'),
      this.translate.instant('general-vinos'),
      this.translate.instant('general-licores'),
      this.translate.instant('general-aguas'),
      this.translate.instant('general-bebidas'),
      this.translate.instant('general-cocktails'),
    ];

    //products - consulta única
    try {
      const productsSnapshot = await this.firestore.collection('products')
        .where('UID_RESTAURANT', '==', uid_restaurant)
        .get();

      productsSnapshot.forEach(doc => {
        const data = doc.data() as Product;
        if (data.tags) {
          tags_products = tags_products.concat(this.objectToArray(data.tags));
        }
      });
    } catch (error) {
      console.error('Error loading products tags:', error);
    }

    //caso primera vez cuando no hay elementos que tengan tags
    this.tags_products = this.cleanDuplicates(tags_products);
    this.tags_products.sort((one, two) => (one.toLowerCase() < two.toLowerCase() ? -1 : 1));
  }

  //recupera los tags de combos (consulta única, sin suscripciones)
  async getComboTags(uid_restaurant) {
    var _tags_combo = [
      this.translate.instant('general-arroces'),
      this.translate.instant('general-bocadillos'),
      this.translate.instant('general-carnes'),
      this.translate.instant('general-ensaladas'),
      this.translate.instant('general-entrantes'),
      this.translate.instant('general-hamburguesas'),
      this.translate.instant('general-mariscos'),
      this.translate.instant('general-pastas'),
      this.translate.instant('general-pescados'),
      this.translate.instant('general-pizzas'),
      this.translate.instant('general-postres'),
      this.translate.instant('general-primeros'),
      this.translate.instant('general-segundos'),
      this.translate.instant('general-sopas'),
      this.translate.instant('general-sugerencias'),
      this.translate.instant('general-tacos'),
      this.translate.instant('general-tapas')];

    //combos - consulta única
    try {
      const combosSnapshot = await this.firestore.collection('menus')
        .where('UID_RESTAURANT', '==', uid_restaurant)
        .where('style', '==', 'combo')
        .get();

      combosSnapshot.forEach(doc => {
        const data = doc.data() as Menu;
        if (data.tags) {
          _tags_combo = _tags_combo.concat(this.objectToArray(data.tags));
        }
      });
    } catch (error) {
      console.error('Error loading combo tags:', error);
    }

    //caso primera vez cuando no hay elementos que tengan tags
    this.tags_combo = this.cleanDuplicates(_tags_combo);
    this.tags_combo.sort((one, two) => (one.toLowerCase() < two.toLowerCase() ? -1 : 1));
  }

  checkIfPRO(uid) {
    this.http.post(this.api_path + 'dashboard/change_dashboardPro?uid=' + uid, {}, {})
      .subscribe(res => {
        this.restaurant.pro = res['pro'];
      });
  }

  getWeatherForecast() {
    var date = moment().format("YYYY-MM-DD");
    const params = new HttpParams()
      .set('lat', this.restaurant.lat)
      .set('lon', this.restaurant.lng)
      .set('date', date)
      .set('lang', this.restaurant.lang);

    this.http.post(this.api_path + 'dashboard/weather_forecast', params, {})
      .subscribe(res => {
        this.weather = res;
      });
  }

  regla3(first, second) {
    return (second * 100) / first;
  }

  returnBigtoLittleMeasurement(quantity, measurement) {

    if (measurement === 'kg' || measurement === 'l') {
      //kg l
      var _return = quantity * 1000;
    } else {
      //units
      _return = quantity;
    }
    return _return;
  }

  returnBigMeasurement(measurement) {
    if (measurement == 'gr') {
      return 'kg';
    } else if (measurement == 'ml') {
      return 'l';
    } else {
      return measurement;
    }
  }

  calculatePrice(price, total_quantity, measurement) {
    var price_ingr;
    if (measurement === 'kg' || measurement === 'l') {
      //kg l
      price_ingr = price * total_quantity;
    } else {
      //units
      price_ingr = price * total_quantity;
    }
    return price_ingr;
  }

  calculateQuantity(quantity, total_quantity, measurement) {
    var _quantity;
    if (measurement === 'kg' || measurement === 'l') {
      //kg l
      _quantity = (quantity * total_quantity) / 1000;
    } else if (measurement === 'gr' || measurement === 'ml') {
      //kg l
      _quantity = (quantity * total_quantity) / 1000;
    } else {
      //units
      _quantity = quantity * total_quantity;
    }
    return _quantity;
  }

  createSubTotal(total, tax) {
    //Quita el Tax del total, de foram correcta

    var sub = total / ((parseFloat(tax) + 100) / 100);
    return sub;

  }

  createTotal(total, tax) {
    //Quita el Tax del total, de foram correcta
    var sub = total + (total * tax / 100);
    return sub;
  }

  public getBrowserName() {
    const agent = window.navigator.userAgent.toLowerCase();
    switch (true) {
      case agent.indexOf('edge') > -1:
        return 'edge';
      case agent.indexOf('opr') > -1 && !!(<any>window).opr:
        return 'opera';
      case agent.indexOf('chrome') > -1 && !!(<any>window).chrome:
        return 'chrome';
      case agent.indexOf('trident') > -1:
        return 'ie';
      case agent.indexOf('firefox') > -1:
        return 'firefox';
      case agent.indexOf('safari') > -1:
        return 'safari';
      default:
        return 'other';
    }
  }

  public returnRolAccess(rol, zone) {
    if (this.user_access.includes('admin')) {
      //admin
      if (zone == 'sidemenu_logout' || zone == 'waiter_dashboard') {
        return false;
      } else {
        return true;
      }
    } else {
      if (zone == 'sidemenu_logout') {
        return true;
      } else {
        //articles
        if (zone == 'foodcost' || zone == 'articles') {
          if (this.user_access.includes('articles')) {
            return true;
          } else {
            return false;
          }
        }

        //menus
        if (zone == 'carta' || zone == 'menus') {
          if (this.user_access.includes('menus')) {
            return true;
          } else {
            return false;
          }
        }

        //pos
        if (zone == 'tpv' || zone == 'pos') {
          if (this.user_access.includes('pos')) {
            return true;
          } else {
            return false;
          }
        }

        //orders
        if (zone == 'orders') {
          if (this.user_access.includes('orders')) {
            return true;
          } else {
            return false;
          }
        }

        //kds
        if (zone == 'kitchen') {
          if (this.user_access.includes('kds')) {
            return true;
          } else {
            return false;
          }
        }

        //takeaway
        if (zone == 'takeaway_delivery' || zone == 'takeaway') {
          if (this.user_access.includes('takeaway')) {
            return true;
          } else {
            return false;
          }
        }

        //reservations
        if (zone == 'reservation') {
          if (this.user_access.includes('reservations')) {
            return true;
          } else {
            return false;
          }
        }

        //stock
        if (zone == 'stock') {
          if (this.user_access.includes('stock')) {
            return true;
          } else {
            return false;
          }
        }

        //analytics
        if (zone == 'sales' || zone == 'analytics' || zone == 'analytics_report' || zone == 'analytics_realtime' || zone == 'analytics_sales_report' || zone == 'income_expenses') {
          if (this.user_access.includes('analytics')) {
            return true;
          } else {
            return false;
          }
        }

        //printer
        if (zone == 'printer') {
          if (this.user_access.includes('printer')) {
            return true;
          } else {
            return false;
          }
        }
      }
    }
  }

  getAllergenName(id_allergen) {
    switch (id_allergen) {
      case '04rgCKokhvB0BuwdWet5': {
        return this.translate.instant('general-indicators-alcohol');
      }
      case '1SlpPqFfsmjec4ZnwK45': {
        return this.translate.instant('general-allergens-huevo');
      }
      case '2L9I1OFi0MttudVUajCy': {
        return this.translate.instant('general-allergens-altramueces');
      }
      case '4VuKpxSZoGRzvNqEdIlu': {
        return this.translate.instant('general-allergens-crustaceos');
      }
      case '4sKpCjitEY6sV3BhwdLq': {
        return this.translate.instant('general-allergens-frutos-secos');
      }
      case '50bkEzjuWbQGCB7IjrEf': {
        return this.translate.instant('general-allergens-gluten');
      }
      case '6QYpvI63JK4XDqsz1995': {
        return this.translate.instant('general-indicators-setas');
      }
      case 'G3bZpwrVP9bJvlOHT6XE': {
        return this.translate.instant('general-allergens-apio');
      }
      case 'H4W23Lv4XHx4qpZCEbYN': {
        return this.translate.instant('general-allergens-pescado');
      }
      case 'Io13IxX1i5BnOpjoyZBF': {
        return this.translate.instant('general-allergens-lactosa');
      }
      case 'JV8kqxMaSd1Q61cwzU9x': {
        return this.translate.instant('general-allergens-soja');
      }
      case 'PAhaRzeD1Fc8Eh9HurEU': {
        return this.translate.instant('general-indicators-picante-suave');
      }
      case 'SDwqJGfd8tGgWVjQnlHK': {
        return this.translate.instant('general-indicators-picante');
      }
      case 'kbTVLXJAOEPY4PNSgA1D': {
        return this.translate.instant('general-indicators-muy-picante');
      }
      case 'SGflJYVDgHRjeItCdim2': {
        return this.translate.instant('general-indicators-maiz');
      }
      case 'TRku0ZmxtpB3M73D8wlD': {
        return this.translate.instant('general-allergens-cacahuetes');
      }
      case 'VxAwcxVQu7ZytAunh4pK': {
        return this.translate.instant('general-indicators-vegetariano');
      }
      case 'WBDYCZPjlBWlXG772MLZ': {
        return this.translate.instant('general-indicators-vegano');
      }
      case 'YGkIQKw7yOfwtHq95aly': {
        return this.translate.instant('general-allergens-dioxido-azufre-sulfitos');
      }
      case 'axhqvt8l5LAG1jba2Heq': {
        return this.translate.instant('general-indicators-ecologico');
      }
      case 'e8v2RnYzGWTH1CboyCR7': {
        return this.translate.instant('general-allergens-sesamo');
      }
      case 'ecE19RgQX1ze3CHY1XJi': {
        return this.translate.instant('general-indicators-kosher');
      }
      case 'hPrDu9pjQmqXBnoxBfet': {
        return this.translate.instant('general-allergens-mostaza');
      }
      case 'jjVvcvGn3gLcMqXy4wKX': {
        return this.translate.instant('general-indicators-cerdo');
      }
      case 'l1ojIaGuVlnyWjFD6WNQ': {
        return this.translate.instant('general-allergens-moluscos');
      }
      case 'mGYwKe2JYwTICu7N7sC6': {
        return this.translate.instant('general-indicators-cafeina');
      }
      case 'q05pas64NVItzqNNq1Nb': {
        return this.translate.instant('general-indicators-halal');
      }
      case 'x0gEJ4cFaVKLaQwfybrQ': {
        return this.translate.instant('general-indicators-infantil');
      }
      case 'FHdPZ4t2S4PjB0IlCnC5': {
        return this.translate.instant('general-indicators-km0');
      }
      case 'qOJouJQSVIEFLGdEkwRs': {
        return this.translate.instant('general-indicators-mediterraneo');
      }
      case 'NL0JHSeK2E4ZA9yLvzAB': {
        return this.translate.instant('general-indicators-comida-rapida');
      }
      case 'juWdKnYZliS2eNez9Geo': {
        return this.translate.instant('general-indicators-recomendado');
      }
      case 'QVZO1ivcXi8gQp5o8XZf': {
        return this.translate.instant('general-indicators-sin-azucar');
      }
      case 'WMZCNDQNjlICEQ1CZzbF': {
        return this.translate.instant('general-indicators-stevia');
      }
    }
  }

  public getLastDays(actual_day, days) {
    let date = new Date(actual_day);
    date.setDate(date.getDate() - days);
    return this.datePipe.transform(date, 'yyyy-MM-dd');
  }

  //tour to specific step
  tourLaunchStep(_step) {
    if (this.tour != '') {
      this.tour_step_user = _step;
    }
  }

  checkIntegrationOpened(integration) {
    var _ret = false;

    switch (integration) {
      case 'covermanager': {
        if (this.restaurant.covermanager) {
          _ret = true;
        }
        break;
      }
      case 'ordatic': {
        if (this.restaurant.ordatic) {
          _ret = true;
        }
        break;
      }
    }
    return _ret;
  }

  measurementLite(measurement) {
    //declare
    var _measurement;
    //check
    if (measurement === 'kg') {
      _measurement = 'gr';
    } else if (measurement === 'l') {
      _measurement = 'ml';
    } else if (measurement === 'ud.') {
      _measurement = 'ud';
    } else if (measurement === 'fl') {
      _measurement = 'fl';
    } else if (measurement === 'gal') {
      _measurement = 'gal';
    } else if (measurement === 'lb') {
      _measurement = 'lb';
    } else if (measurement === 'oz') {
      _measurement = 'oz';
    } else if (measurement === 'pint') {
      _measurement = 'pint';
    }

    //return
    return _measurement;
  }

  checkCurrencyLang(lang) {
    var currency_lang = 'es';
    if (lang == 'es') {
      currency_lang = lang;
    } else if (lang == 'en') {
      currency_lang = lang;
    }

    return currency_lang;
  }


  returnDate(date) {
    if (this.restaurant.format_date) {
      return this.datepipe.transform(date, this.restaurant.format_date);
    } else {
      return this.datepipe.transform(date, 'd/MM/yyyy');
    }
  }

  returnTime(date) {
    if (this.restaurant.format_time) {
      return this.datepipe.transform(date, this.restaurant.format_time);
    } else {
      return this.datepipe.transform(date, 'HH:mm:ss');
    }
  }

  returnDateMoment(date) {
    return moment(date).format('DD/MM/yyyy');
  }

  returnTimeMoment(date) {
    return moment(date).format('HH:mm:ss');
  }

  returnDay(date) {
    return moment(date).locale(this.currency_lang).format('dddd');
  }

  setTranslate() {
    if (this.restaurant.lang == 'es') {
      this.translate.use('es');
    } else if (this.restaurant.lang == 'ca') {
      this.translate.use('ca');
    } else if (this.restaurant.lang == 'it') {
      this.translate.use('it');
    } else {
      this.translate.use('en');
    }
  }

  nameLangSelectDish(dish) {
    switch (this.restaurant.lang) {
      case 'es': {
        //statements;
        if (dish.name_es == null || dish.name_es == '') {
          return '';
        } else {
          return dish.name_es;
        }
      }
      case 'ca': {
        //statements;
        if (dish.name_ca == null || dish.name_ca == '') {
          return '';
        } else {
          return dish.name_ca;
        }
      }
      case 'en': {
        //statements;
        if (dish.name_en == null || dish.name_en == '') {
          return '';
        } else {
          return dish.name_en;
        }
      }
      case 'de': {
        //statements;
        if (dish.name_de == null || dish.name_de == '') {
          return '';
        } else {
          return dish.name_de;
        }
      }
      case 'fr': {
        //statements;
        if (dish.name_fr == null || dish.name_fr == '') {
          return '';
        } else {
          return dish.name_fr;
        }
      }
      case 'it': {
        //statements;
        if (dish.name_it == null || dish.name_it == '') {
          return '';
        } else {
          return dish.name_it;
        }
      }
      default: {
        //statements;
        if (dish.name_es == null || dish.name_es == '') {
          return '';
        } else {
          return dish.name_es;
        }
      }
    }
  }
  nameLangSelectMenu(menu) {
    switch (this.restaurant.lang) {
      case 'es': {
        //statements;
        if (menu.title_es == null || menu.title_es == '') {
          return '';
        } else {
          return menu.title_es;
        }
      }
      case 'ca': {
        //statements;
        if (menu.title_ca == null || menu.title_ca == '') {
          return '';
        } else {
          return menu.title_ca;
        }
      }
      case 'en': {
        //statements;
        if (menu.title_en == null || menu.title_en == '') {
          return '';
        } else {
          return menu.title_en;
        }
      }
      case 'de': {
        //statements;
        if (menu.title_de == null || menu.title_de == '') {
          return '';
        } else {
          return menu.title_de;
        }
      }
      case 'fr': {
        //statements;
        if (menu.title_fr == null || menu.title_fr == '') {
          return '';
        } else {
          return menu.title_fr;
        }
      }
      case 'it': {
        //statements;
        if (menu.title_it == null || menu.title_it == '') {
          return '';
        } else {
          return menu.title_it;
        }
      }
      default: {
        //statements;
        if (menu.title_es == null || menu.title_es == '') {
          return '';
        } else {
          return menu.title_es;
        }
      }
    }
  }
  nameLangSelectCarta(carta) {
    switch (this.restaurant.lang) {
      case 'es': {
        //statements;
        if (carta.name == null || carta.name == '') {
          return '';
        } else {
          return carta.name;
        }
      }
      case 'ca': {
        //statements;
        if (carta.name_ca == null || carta.name_ca == '') {
          return '';
        } else {
          return carta.name_ca;
        }
      }
      case 'en': {
        //statements;
        if (carta.name_en == null || carta.name_en == '') {
          return '';
        } else {
          return carta.name_en;
        }
      }
      case 'de': {
        //statements;
        if (carta.name_de == null || carta.name_de == '') {
          return '';
        } else {
          return carta.name_de;
        }
      }
      case 'fr': {
        //statements;
        if (carta.name_fr == null || carta.name_fr == '') {
          return '';
        } else {
          return carta.name_fr;
        }
      }
      case 'it': {
        //statements;
        if (carta.name_it == null || carta.name_it == '') {
          return '';
        } else {
          return carta.name_it;
        }
      }
      default: {
        //statements;
        if (carta.name == null || carta.name == '') {
          return '';
        } else {
          return carta.name;
        }
      }
    }
  }
  nameLangSelectProduct(product) {
    switch (this.restaurant.lang) {
      case 'es': {
        //statements;
        if (product.name == null || product.name == '') {
          return '';
        } else {
          return product.name;
        }
      }
      case 'ca': {
        //statements;
        if (product.name_ca == null || product.name_ca == '') {
          return '';
        } else {
          return product.name_ca;
        }
      }
      case 'en': {
        //statements;
        if (product.name_en == null || product.name_en == '') {
          return '';
        } else {
          return product.name_en;
        }
      }
      case 'de': {
        //statements;
        if (product.name_de == null || product.name_de == '') {
          return '';
        } else {
          return product.name_de;
        }
      }
      case 'fr': {
        //statements;
        if (product.name_fr == null || product.name_fr == '') {
          return '';
        } else {
          return product.name_fr;
        }
      }
      case 'it': {
        //statements;
        if (product.name_it == null || product.name_it == '') {
          return '';
        } else {
          return product.name_it;
        }
      }
      default: {
        //statements;
        if (product.name == null || product.name == '') {
          return '';
        } else {
          return product.name;
        }
      }
    }
  }
  nameLangSelectIngredient(ingredient) {
    switch (this.restaurant.lang) {
      case 'es': {
        //statements;
        return ingredient.name
      }
      case 'ca': {
        //statements;
        return ingredient.name_ca
      }
      case 'en': {
        //statements;
        return ingredient.name_en
      }
      case 'de': {
        //statements;
        return ingredient.name_de
      }
      case 'fr': {
        //statements;
        return ingredient.name_fr
      }
      case 'it': {
        //statements;
        return ingredient.name_it
      }
      default: {
        //statements;
        return ingredient.name
      }
    }
  }
  descriptionLangSelectArticle(article) {
    switch (this.restaurant.lang) {
      case 'es': {
        //statements;
        if (article.description_es == null || article.description_es == '') {
          return '';
        } else {
          return article.description_es;
        }
      }
      case 'ca': {
        //statements;
        if (article.description_ca == null || article.description_ca == '') {
          return '';
        } else {
          return article.description_ca;
        }
      }
      case 'en': {
        //statements;
        if (article.description_en == null || article.description_en == '') {
          return '';
        } else {
          return article.description_en;
        }
      }
      case 'de': {
        //statements;
        if (article.description_de == null || article.description_de == '') {
          return '';
        } else {
          return article.description_de;
        }
      }
      case 'fr': {
        //statements;
        if (article.description_fr == null || article.description_fr == '') {
          return '';
        } else {
          return article.description_fr;
        }
      }
      case 'it': {
        //statements;
        if (article.description_it == null || article.description_it == '') {
          return '';
        } else {
          return article.description_it;
        }
      }
      default: {
        //statements;
        if (article.description_es == null || article.description_es == '') {
          return '';
        } else {
          return article.description_es;
        }
      }
    }
  }

  nameNotEsLang(item) {
    // Orden de prioridad de idiomas
    const langs = [
      { key: 'es', field: item.type === 'dish' ? 'name_es' : 'name' },
      { key: 'ca', field: 'name_ca' },
      { key: 'en', field: 'name_en' },
      { key: 'de', field: 'name_de' },
      { key: 'fr', field: 'name_fr' },
      { key: 'it', field: 'name_it' },
    ];
    // Buscar el campo correspondiente al idioma actual
    let currentLang = this.restaurant.lang;
    let currentField = langs.find(l => l.key === currentLang).field || (item.type === 'dish' ? 'name_es' : 'name');
    let value = item[currentField];
    if (value !== undefined && value !== null && value !== '') {
      return value;
    }
    // Si está vacío, buscar el primer nombre disponible en cualquier idioma
    for (let lang of langs) {
      let v = item[lang.field];
      if (v !== undefined && v !== null && v !== '') {
        return v;
      }
    }
    // Si todos están vacíos, devolver vacío
    return '';
  }

  getNameIngProd(element) {
    var _return = element.name;
    if (element.type == 'product') {
      _return = this.nameLangSelectProduct(element);
    } else {
      _return = this.nameLangSelectIngredient(element);
    }
    return _return;
  }

  //funcion que pasa de timestamp a fecha
  timestampToDate(date) {
    var _date = new Date();
    if (date.seconds) {
      _date = new Date(date.seconds * 1000);
    } else if (date._seconds) {
      _date = new Date(date._seconds * 1000);
    } else {
      var checkDate: any = new Date(date);
      if (checkDate instanceof Date) {
        _date = date;
      }
    }

    return moment(_date).format('YYYY/MM/DD HH:mm:ss');
  }

  timestampToDateWithFormat(date, format) {
    var _date = new Date();
    if (date.seconds) {
      _date = new Date(date.seconds * 1000);
    } else if (date._seconds) {
      _date = new Date(date._seconds * 1000);
    } else {
      var checkDate: any = new Date(date);
      if (checkDate instanceof Date) {
        _date = date;
      }
    }

    return moment(_date).format(format);
  }

  //funcion que lanza un toast cuando no hay conexion a internet.
  launchToastNoConnection() {
    let toast = this.toastCtrl.create({
      message: this.translate.instant('general-offline-funcion-desactivada'),
      duration: 3000,
      position: 'bottom'
    });
    toast.present();
  }

  //funcion que devuelve una key publica
  async getPublicKey() {
    const publickeyRef = this.firestore.collection('public_key');
    //recuperar public key en firestore con la private
    await publickeyRef.where('UID_RESTAURANT', '==', this.restaurant_uid).get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          this.public_key = doc.id;
        });
      });
    //caso no existe creamos public_key
    if (this.public_key === '') {
      await this.afs.collection('public_key').add({
        UID_RESTAURANT: this.restaurant_uid
      }).then(doc => {
        this.public_key = doc.id;
      });
    }
  }

  //funcion que devuelve el campo de plato o producto por el idioma.
  returnLangTag(type) {
    switch (this.restaurant.lang) {
      case 'es': {
        if (type == 'product') {
          return 'name'
        } else {
          return 'name_es'
        }
      }
      case 'ca': {
        return 'name_ca'
      }
      case 'en': {
        return 'name_en'
      }
      case 'de': {
        return 'name_de'
      }
      case 'fr': {
        return 'name_fr'
      }
      case 'it': {
        return 'name_it'
      }
      default: {
        return 'name_en'
      }
    }
  }

  returnLangCartaMenuCombo(element) {
    switch (this.restaurant.lang) {
      case 'es': {
        if (element.name) {
          return element.name
        } else {
          return element.title_es
        }
      }
      case 'ca': {
        if (element.name_ca) {
          return element.name_ca
        } else {
          return element.title_ca
        }
      }
      case 'en': {
        if (element.name_en) {
          return element.name_en
        } else {
          return element.title_en
        }
      }
      case 'de': {
        if (element.name_de) {
          return element.name_de
        } else {
          return element.title_de
        }
      }
      case 'fr': {
        if (element.name_fr) {
          return element.name_fr
        } else {
          return element.title_fr
        }
      }
      case 'it': {
        if (element.name_it) {
          return element.name_it
        } else {
          return element.title_it
        }
      }
      default: {
        if (element.name_en) {
          return element.name_en
        } else {
          return element.title_en
        }
      }
    }
  }

  returnSubtitleLangCartaMenuCombo(element) {
    switch (this.restaurant.lang) {
      case 'es': {
        if (element.subtitle_es == undefined || element.subtitle_es == null || element.subtitle_es == '') {
          return element.subtitle_es
        } else {
          return '';
        }
      }
      case 'ca': {
        if (element.subtitle_ca == undefined || element.subtitle_ca == null || element.subtitle_ca == '') {
          return element.subtitle_ca
        } else {
          return '';
        }
      }
      case 'en': {
        if (element.subtitle_en == undefined || element.subtitle_en == null || element.subtitle_en == '') {
          return element.subtitle_en
        } else {
          return '';
        }
      }
      case 'de': {
        if (element.subtitle_de == undefined || element.subtitle_de == null || element.subtitle_de == '') {
          return element.subtitle_de
        } else {
          return '';
        }
      }
      case 'fr': {
        if (element.subtitle_fr == undefined || element.subtitle_fr == null || element.subtitle_fr == '') {
          return element.subtitle_fr
        } else {
          return '';
        }
      }
      case 'it': {
        if (element.subtitle_it == undefined || element.subtitle_it == null || element.subtitle_it == '') {
          return element.subtitle_it
        } else {
          return '';
        }
      }
      default: {
        if (element.subtitle_es == undefined || element.subtitle_es == null || element.subtitle_es == '') {
          return element.subtitle_es
        } else {
          return '';
        }
      }
    }
  }

  //funcion que devuelve solo los elementos que no son de un combo.
  returnOnlyNoComboElements(elements) {
    var elements_list = [];
    //mirar que es combo o no
    for (let element of this.objectToArray(elements)) {
      if (element.type != 'combo' && element.uid_combo_tmp != undefined) {//caso los que son part del combo para no mostrarlos
      } else {//todos los que no son elementos de un combo
        elements_list.push(element);
      }
    }
    return elements_list;
  }

  //funcion que mira y devuelve el idioma pasado
  returnLangBrowser(lang) {
    switch (lang) {
      case 'es': {//caso todos los es
        return 'es';
      }
      case 'eu': {//caso euskera
        return 'es';
      }
      case 'gl': {//caso gallego
        return 'es';
      }
      case 'ca': {//caso catalan
        return 'ca';
      }
      default: {//defecto en
        return 'en';
      }
    }
  }

  //función que devuelve booleano segun sin esta activada o no el orders_persons_elements
  ordersPersonsElements(origin) {
    switch (this.restaurant.orders_persons_elements) {
      case true: {
        if (origin == 'order') {
          return true;
        } else {
          return false;
        }
      }
      case false: {
        if (origin == 'order') {
          return false;
        } else {
          return false;
        }
      }
      default: {
        return false
      }
    }
  }

  //funcion que nos dice si el numero pasado es negativo o no.
  negativeNumber(number) {
    if (number < 0) {
      return true;
    } else {
      return false;
    }
  }

  //funcion que busca las imagenes del about us
  public getWebAboutusImageUrl(image_ref, img_number) {
    //Get image url for show. Lo utilitzamos en las classes de las views para utlitzarlas al momento ya que la funcion no tiene await.
    const ref = this.storage.ref(image_ref);
    if (img_number == 1) {
      this.web_aboutus_url1 = ref.getDownloadURL();
    } else if (img_number == 2) {
      this.web_aboutus_url2 = ref.getDownloadURL();
    } else {
      this.web_aboutus_url3 = ref.getDownloadURL();
    }

    var webimg = image_ref;
    let img = document.createElement("img");
    img.src = "https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/web%2Faboutus%2F" + webimg.substr(12) + "?alt=media";
  }

  //funcion para redondear a 2 deciamles.
  round2decimal(num) {
    return Math.round((num + Number.EPSILON) * 100) / 100;
  }

  //funcion que ordena alfabeticamente un array simple. ej> {0:'alo',1:'presidente'}
  orderNamesByAlphabetical(array_elements) {
    //return array_elements.sort((one, two) => (one < two ? -1 : 1));
    if (array_elements != undefined) {
      return array_elements.sort(function (a, b) {
        if (a.toLowerCase() < b.toLowerCase()) { return -1; }
        if (a.toLowerCase() > b.toLowerCase()) { return 1; }
        return 0;
      });
    }
  }

  async getDominiSites() {
    const publicKeyRef = this.firestore.collection('public_key');
    //Recuperem el domini del restaurant
    publicKeyRef.where('UID_RESTAURANT', '==', this.restaurant_uid)
      .get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          let data = doc.data();
          //Si tiene el addon pro cogemos el dominio
          if (this.checkLimitsByLicense('sites', 'sites')) {
            if (data.domini) {
              this.domini_sites = data.domini;
            } else {
              this.domini_sites = doc.id;
            }
          } else {
            this.domini_sites = doc.id;
          }
        });
      });
  }

  async getPublicKeyDominiSites() {
    //Check if have public_key
    await this.getPublicKey();
    //Get sites
    await this.getDominiSites();
  }

  async delay(ms) {
    // return await for better async stack trace support in case of errors.
    return await new Promise(resolve => setTimeout(resolve, ms));
  }

  calculateIva(total, subtotal) {
    return parseFloat(total) - parseFloat(subtotal);
  }

  timestampOrDate4ReturnDate(date) {
    if (date.seconds) {
      return date.toDate();
    } else {
      return date;
    }
  }

  ifVarEmpty(variable) {
    if (variable != undefined) {
      return variable;
    } else {
      return '';
    }
  }

  replaceChar(newstr, chart2Replace) {
    return newstr.replace(chart2Replace, " ");
  }

  sendDataToDataCollection(type, extra) {
    //Funcion que dependiendo del type, envia una informacion u otra en la collection _data
    switch (type) {
      case "pro_new": {
        //Insertamos en la collection _data (type, register, pro, pro_new)
        this.insertInCollectionDataMKTKPI('MKTKPI', 0, 1, 0);
        break;
      }
      case "register": {
        //Insertamos en la collection _data (type, register, pro, pro_new)
        this.insertInCollectionDataMKTKPI('MKTKPI', 1, 0, 0);
        break;
      }
      case "data_set": {
        //Insertamos en la collection _data (type, extra info)
        this.insertInCollectionDataDataSet('data_set', extra);
        break;
      }
      case "log_set": {
        //Insertamos en la collection _data (type, extra info)
        this.insertInCollectionDataLogSet('log_set', extra);
        break;
      }
      default: {
        break;
      }
    }
  }

  async insertInCollectionDataMKTKPI(type, register, pro, pro_new) {
    //Funcion que inserta en la collection _data un registro, pro o pro_new
    await this.afs.collection('_data').add({
      type: type,
      email: this.restaurant.email,
      date: moment().format('YYYY-MM-DD HH:mm:ss'),
      register: register,
      pro: pro,
      pro_new: pro_new,
      browser: this.ifVarEmpty(this.restaurant.sherlock_browser),
      campaign: this.ifVarEmpty(this.restaurant.sherlock_campaign),
      country: this.ifVarEmpty(this.restaurant.address_country),
      origin: this.ifVarEmpty(this.restaurant.sherlock_origin),
      os_platform: this.ifVarEmpty(this.restaurant.sherlock_os_platform),
      web: this.ifVarEmpty(this.restaurant.sherlock_web),
      buyer_persona: this.ifVarEmpty(this.restaurant.buyer_person),
      business: this.ifVarEmpty(this.restaurant.business),
      business2: this.ifVarEmpty(this.restaurant.business2),
      cuisine: this.ifVarEmpty(this.restaurant.cuisine),
      cuisine2: this.ifVarEmpty(this.restaurant.cuisine2)
    }).then(async doc => { });
  }

  async insertInCollectionDataDataSet(type, extra) {
    //Funcion que inserta en la collection _data para el data
    await this.afs.collection('_data').add({
      type: type,
      email: this.restaurant.email,
      domini: this.restaurant_uid,
      date: moment().format('YYYY-MM-DD HH:mm:ss'),
      name: extra.name,
      tipo1: this.ifVarEmpty(this.restaurant.cuisine),
      tipo2: this.ifVarEmpty(this.restaurant.cuisine2),
      tipo3: null,
      lat: this.ifVarEmpty(this.restaurant.lat),
      long: this.ifVarEmpty(this.restaurant.lng),
      value: extra.value,
      value_id: extra.value_id,
      extra: extra.extra,
      test: extra.test,
      business1: this.ifVarEmpty(this.restaurant.business),
      business2: this.ifVarEmpty(this.restaurant.business2),
    }).then(async doc => { });
  }

  async insertInCollectionDataLogSet(type, extra) {
    //Funcion que inserta en la collection _data para el log
    await this.afs.collection('_data').add({
      type: type,
      email: this.restaurant.email,
      date: moment().format('YYYY-MM-DD HH:mm:ss'),
      category: extra.category,
      domini: this.restaurant_uid,
      extra: extra.extra,
      page: extra.page,
      restaurant: this.ifVarEmpty(this.restaurant.company),
      rol: extra.rol,
      type_extra: extra.type,
      user: extra.user,
      tipo1: this.ifVarEmpty(this.restaurant.cuisine),
      tipo2: this.ifVarEmpty(this.restaurant.cuisine2),
      lat: this.ifVarEmpty(this.restaurant.lat),
      long: this.ifVarEmpty(this.restaurant.lng),
      business1: this.ifVarEmpty(this.restaurant.business),
      business2: this.ifVarEmpty(this.restaurant.business2),
      provider: this.ifVarEmpty(this.restaurant.provider),
      platform_name: this.ifVarEmpty(this.platform_name),
      so_name: this.ifVarEmpty(this.so_name),
      app: 'APP2'
    }).then(async doc => { });
  }

  apiUidRestaurant() {
    return this.restaurant_uid.substring(0, 3);
  }

  taxOfValue(value, tax) {
    var tax_return = (parseFloat(value) * parseFloat(tax)) / 100;
    return tax_return;
  }

  returnTag2TranslateMoth(month) {
    switch (month) {
      case 'January': {
        return 'general-january';
      }
      case 'February': {
        return 'general-february';
      }
      case 'March': {
        return 'general-march';
      }
      case 'April': {
        return 'general-april';
      }
      case 'May': {
        return 'general-may';
      }
      case 'June': {
        return 'general-june';
      }
      case 'July': {
        return 'general-july';
      }
      case 'August': {
        return 'general-august';
      }
      case 'September': {
        return 'general-september';
      }
      case 'October': {
        return 'general-october';
      }
      case 'November': {
        return 'general-november';
      }
      case 'December': {
        return 'general-december';
      }

    }
  }

  getUserAuthByUid(UID_USER) {
    //Buscamos en el array de usuarios, el que coincida con el uid del usuario, para devolver el uid_auth
    var index = this.users_array.findIndex(x => x.uid == UID_USER);
    var user_auth = "";
    if (index >= 0) {
      user_auth = this.users_array[index].uid_auth;
    }
    return user_auth;
  }

  //funcion global que lanza toasts
  launchToast(message, duration, position) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: duration,
      position: position,
    });
    toast.present();
  }

  //funcion que lanza alert de mesa pagada
  launchAlertTablePaid(table, origin) {
    this.table_paid_alert = true;
    //
    var title = '';
    var msg = `
    <div>
    <p>Pedido #`+ table.ticket.number + ` pagado</p>
    <p class="m-b-0"><strong>`+ this.translate.instant('general-metodo-pago') + `:</strong></p>
    <p class="m-b-0">`+ this.returnPaymentType(table.payment_source) + `</p>
    </div>`;
    //
    if (origin == 'tk') {
      title = 'El takeaway ' + table.ticket.delivery + ' se ha cobrado';
    } else {
      title = 'La mesa ' + table.name + ' se ha cobrado';
    }


    let alert = this.alertCtrl.create({
      title: title,
      message: msg,
      enableBackdropDismiss: false,
      buttons: [
        {
          text: this.translate.instant('general-cerrar'),
          handler: () => {
            this.updatePopupTablePaid(table.UID);
          }
        }
      ]
    });
    alert.present();
  }

  //
  updatePopupTablePaid(uid_table) {
    // Validate that uid_table is not empty
    if (!uid_table || uid_table.trim() === '') {
      console.error('updatePopupTablePaid: uid_table is empty or undefined');
      return;
    }

    this.afs.collection('tables').doc(uid_table).update({
      'payment': false,
      'payment_source': '',
    });
    this.table_paid_alert = false;
  }

  returnPaymentType(payment) {
    switch (payment) {
      case 'cash':
        return this.translate.instant('general-efectivo');
      case 'card':
        return this.translate.instant('general-tarjeta');
      case 'not specified':
        return this.translate.instant('general-no-especifico');
      case 'stripe':
        return this.translate.instant('general-tarjeta-online');
      case 'paypal':
        return 'Paypal';
      case 'payplaza':
        return 'CM.com';
      case 'verifone':
        return 'Verifone';
      case 'redsys':
        return 'Redsys';
      case 'getnet':
        return 'Getnet by Santander';
      case 'getnet_top':
        return 'Getnet by Santander';
      case 'comerciaglobalpay':
        return 'CaixaBank';
      case 'comerciaglobalpay_top':
        return 'CaixaBank';
      case 'btc':
        return 'Bitcoin';
      case 'bch':
        return 'Bitcoin Cash';
      case 'dai':
        return 'Dai';
      case 'doge':
        return 'Dogecoin';
      case 'eth':
        return 'Ethereum';
      case 'ltc':
        return 'Litecoin';
      case 'usdc':
        return 'USD Coin';
      //new
      case 'bank_transfer':
        return this.translate.instant('general-bank-transfer');
      case 'american_express':
        return this.translate.instant('general-american-express');
      case 'bizum':
        return 'Bizum';
      case 'online':
        return 'Online';
      case 'bank_draft':
        return this.translate.instant('general-bank-draft');
      case 'cryptocurrencies':
        return this.translate.instant('pay-cryptomonedas');
      case 'ticket_restaurant':
        return this.translate.instant('general-ticket-restaurant');
      default:
        return '';
    }
  }

  checkPaymentsMctPayActive() {
    //Comprovamos si alguno de los metodos esta activo
    if (this.restaurant.license == 'free') {
      return false;
    } else {
      if (this.restaurant.payment_method_stripe || this.restaurant.payment_method_paypal || this.restaurant.payment_method_payplaza || this.restaurant.payment_method_verifone || this.restaurant.payment_method_crypto || this.restaurant.payment_method_verifone || this.restaurant.payment_method_redsys) {
        return true;
      } else {
        return false;
      }
    }
  }

  /******************************************/
  public limits = {
    //DISHES
    "dishes": {
      "analitycs": {
        "free": true,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      },
      "langs": {
        "free": false,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      },
      "allergens": {
        "free": true,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      },
      "indicators": {
        "free": false,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      },
      "image": {
        "free": false,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      },
      "foodcost": {
        "free": false,
        "basic": false,
        "pro": true,
        "business": true,
        "school": true
      },
      "3prices": {
        "free": false,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      },
      "favourites": {
        "free": false,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      },
      "watermark": {
        "free": true,
        "basic": true,
        "pro": false,
        "business": false,
        "school": false
      },
      "nutrition": {
        "free": false,
        "basic": false,
        "pro": true,
        "business": true,
        "school": true
      },
      "suplements": {
        "free": false,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      },
      "max_dishes": {
        "free": -1,
        "basic": -1,
        "pro": -1,
        "business": -1,
        "school": -1
      },
      "observations": {
        "free": false,
        "basic": false,
        "pro": true,
        "business": true,
        "school": true
      },
      "recipe": {
        "free": false,
        "basic": false,
        "pro": true,
        "business": true,
        "school": true
      },
      "import": {
        "free": false,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      },
      "activable_tpv": {
        "free": false,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      },
      "print": {
        "free": false,
        "basic": false,
        "pro": true,
        "business": true,
        "school": true
      },
      "variations_favourites": {
        "free": false,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      },
      "complements": {
        "free": false,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      },
      "ai": {
        "free": false,
        "basic": false,
        "pro": true,
        "business": true,
        "school": false
      },
      "update_prices": {
        "free": false,
        "basic": false,
        "pro": true,
        "business": true,
        "school": true
      }
    },
    //STOCK
    "stock": {
      "analitycs": {
        "free": true,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      },
      "key_data": {
        "free": false,
        "basic": false,
        "pro": false,
        "business": true,
        "school": true
      },
      "alert": {
        "free": false,
        "basic": false,
        "pro": true,
        "business": true,
        "school": true
      },
      "deduct": {
        "free": false,
        "basic": false,
        "pro": true,
        "business": true,
        "school": true
      },
      "ings_prods": {
        "free": -1,
        "basic": -1,
        "pro": -1,
        "business": -1,
        "school": -1
      },
      "subrecipe": {
        "free": false,
        "basic": false,
        "pro": true,
        "business": true,
        "school": true
      },
      "providers": {
        "free": 0,
        "basic": 0,
        "pro": -1,
        "business": -1,
        "school": -1
      },
      "import": {
        "free": false,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      },
      "delivery_notes": {
        "free": false,
        "basic": false,
        "pro": true,
        "business": true,
        "school": true
      },
      "ai_delivery_notes": {
        "free": false,
        "basic": false,
        "pro": true,
        "business": true,
        "school": false
      },
      "pedidos": {
        "free": false,
        "basic": false,
        "pro": true,
        "business": true,
        "school": true
      },
      "update_inventory": {
        "free": false,
        "basic": false,
        "pro": true,
        "business": true,
        "school": true
      },
      "update_stock": {
        "free": false,
        "basic": false,
        "pro": true,
        "business": true,
        "school": true
      },
      "favourites": {
        "free": false,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      },
      "3prices": {
        "free": false,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      },
      "suplements": {
        "free": false,
        "basic": false,
        "pro": true,
        "business": true,
        "school": true
      },
      "activable_tpv": {
        "free": false,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      },
      "allergens": {
        "free": true,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      },
      "indicators": {
        "free": false,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      },
      "observations": {
        "free": false,
        "basic": false,
        "pro": true,
        "business": true,
        "school": true
      },
      "description_prod": {
        "free": false,
        "basic": false,
        "pro": true,
        "business": true,
        "school": true
      },
      "variations_favourites": {
        "free": false,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      },
      "complements": {
        "free": false,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      },
      "ings": {
        "free": false,
        "basic": false,
        "pro": true,
        "business": true,
        "school": true
      },
      "image": {
        "free": false,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      },
      "langs": {
        "free": false,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      },
      "print": {
        "free": false,
        "basic": false,
        "pro": true,
        "business": true,
        "school": true
      }
    },
    //MENUS/COMBOS
    "daily_menu": {
      "analitycs": {
        "free": true,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      },
      "limit": {
        "free": -1,
        "basic": -1,
        "pro": -1,
        "business": -1,
        "school": -1
      },
      "type": {
        "free": -1,
        "basic": -1,
        "pro": -1,
        "business": -1,
        "school": -1
      },
      "limit_combo": {
        "free": -1,
        "basic": -1,
        "pro": -1,
        "business": -1,
        "school": -1
      },
      "templates": {
        "free": -1,
        "basic": -1,
        "pro": -1,
        "business": -1,
        "school": -1
      },
      "print": {
        "free": true,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      },
      "favourites": {
        "free": false,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      },
      "watermark": {
        "free": true,
        "basic": true,
        "pro": false,
        "business": false,
        "school": false
      },
      "digital_daily_menu": {
        "free": true,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      },
      "activable_tpv": {
        "free": false,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      },
      "suplements": {
        "free": true,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      },
      "langs": {
        "free": true,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      },
      "foodcost": {
        "free": true,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      }
    },
    //CARTA
    "menus": {
      "max_menus": {
        "free": -1,
        "basic": -1,
        "pro": -1,
        "business": -1,
        "school": -1
      },
      "analytics": {
        "free": true,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      },
      "watermark": {
        "free": true,
        "basic": true,
        "pro": false,
        "business": true,
        "school": true
      },
      "print": {
        "free": true,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      },
      "template": {
        "free": -1,
        "basic": -1,
        "pro": -1,
        "business": -1,
        "school": -1
      },
      "digital_menu": {
        "free": true,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      },
      "langs": {
        "free": true,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      }
    },
    //TPV
    "tpv": {
      "rooms": {
        "free": 1,
        "basic": -1,
        "pro": -1,
        "business": -1,
        "school": -1
      },
      "takeaway": {
        "free": false,
        "basic": false,
        "pro": true,
        "business": true,
        "school": true
      },
      "deliveries": {
        "free": false,
        "basic": false,
        "pro": true,
        "business": true,
        "school": true
      },
      "comandero": {
        "free": false,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      },
      "offline": {
        "free": false,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      },
      "map": {
        "free": false,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      },
      "favourites": {
        "free": false,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      },
      "indv_ticket": {
        "free": false,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      },
      "digital_ticket": {
        "free": false,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      },
      "discounts": {
        "free": false,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      },
      "variations": {
        "free": false,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      },
      "complements": {
        "free": false,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      },
      "invoices": {
        "free": false,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      },
      "multi_cash": {
        "free": false,
        "basic": false,
        "pro": false,
        "business": true,
        "school": true
      },
      "send_kitchen": {
        "free": false,
        "basic": false,
        "pro": true,
        "business": true,
        "school": true
      },
      "complete_order": {
        "free": false,
        "basic": false,
        "pro": false,
        "business": true,
        "school": true
      },
      "marchar_cocina": {
        "free": false,
        "basic": false,
        "pro": true,
        "business": true,
        "school": true
      },
      "observations": {
        "free": false,
        "basic": false,
        "pro": true,
        "business": true,
        "school": true
      },
      "horary": {
        "free": false,
        "basic": false,
        "pro": false,
        "business": true,
        "school": true
      },
      "add_custom_element": {
        "free": false,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      },
      "search_products": {
        "free": false,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      },
      "tpv": {
        "free": false,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      }
    },
    //KITCHEN
    "kitchen": {
      "kitchen": {
        "free": false,
        "basic": false,
        "pro": true,
        "business": true,
        "school": true
      },
      "categories": {
        "free": false,
        "basic": false,
        "pro": true,
        "business": true,
        "school": true
      },
      "notify_waiter": {
        "free": false,
        "basic": false,
        "pro": false,
        "business": true,
        "school": true
      }
    },
    //SALES
    "sales": {
      "tickets": {
        "free": false,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      },
      "invoices": {
        "free": false,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      },
      "invoices_to_pay": {
        "free": false,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      },
      "analytics": {
        "free": true,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      },
      "customers": {
        "free": false,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      },
      "customers_analytics": {
        "free": false,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      },
      "customers_export": {
        "free": false,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      },
      "close_cash": {
        "free": "basic",
        "basic": "basic",
        "pro": "basic plus",
        "business": "full",
        "school": "full"
      },
      "ratings": {
        "free": false,
        "basic": false,
        "pro": true,
        "business": true,
        "school": true
      },
      "watermark": {
        "free": true,
        "basic": true,
        "pro": false,
        "business": false,
        "school": false
      }
    },
    //INCOME EXPENSES
    "incomes_expenses": {
      "analytics": {
        "free": true,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      },
      "export_tax": {
        "free": false,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      },
      "import_incomes": {
        "free": false,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      },
      "import_expenses": {
        "free": false,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      }
    },
    //SITES
    "sites": {
      "sites": {
        "free": false,
        "basic": false,
        "pro": true,
        "business": true,
        "school": true
      },
      "digital_card": {
        "free": false,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      },
      "reservations": {
        "free": false,
        "basic": false,
        "pro": true,
        "business": true,
        "school": true
      },
      "url": {
        "free": false,
        "basic": false,
        "pro": true,
        "business": true,
        "school": true
      },
      "order": {
        "free": false,
        "basic": false,
        "pro": true,
        "business": true,
        "school": true
      },
      "web_config": {
        "free": false,
        "basic": false,
        "pro": true,
        "business": true,
        "school": true
      }
    },
    //RESERVATIONS
    "reservations": {
      "calendar": {
        "free": false,
        "basic": false,
        "pro": true,
        "business": true,
        "school": true
      },
      "analytics": {
        "free": true,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      },
      "print": {
        "free": false,
        "basic": false,
        "pro": true,
        "business": true,
        "school": true
      },
      "mark_complete": {
        "free": false,
        "basic": false,
        "pro": true,
        "business": true,
        "school": true
      },
      "sites": {
        "free": false,
        "basic": false,
        "pro": true,
        "business": true,
        "school": true
      }
    },
    //SCREEN BLOCK
    "screen_block": {
      "block": {
        "free": false,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      }
    },
    //PRINTS
    "printers": {
      "config_printers": {
        "free": false,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      }
    },
    //LOGS
    "logs": {
      "movements_list": {
        "free": true,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      }
    },
    //CUSTOMERS
    "customer_services": {
      "customer_services": {
        "free": 0,
        "basic": 0,
        "pro": 72,
        "business": 24,
        "school": 24
      }
    },
    //CONFIG
    "config": {
      "users": {
        "free": 1,
        "basic": 2,
        "pro": 3,
        "business": -1,
        "school": 1
      },
      "integrations": {
        "free": false,
        "basic": false,
        "pro": false,
        "business": true,
        "school": true
      },
      "lite_integrations": {
        "free": false,
        "basic": false,
        "pro": true,
        "business": true,
        "school": true
      },
      "multi_cash": {
        "free": false,
        "basic": false,
        "pro": false,
        "business": true,
        "school": true
      },
      "notification": {
        "free": false,
        "basic": false,
        "pro": true,
        "business": true,
        "school": true
      },
      "rooms": {
        "free": 1,
        "basic": -1,
        "pro": -1,
        "business": -1,
        "school": -1
      },
      "variations": {
        "free": false,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      },
      "complements": {
        "free": false,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      },
      "map": {
        "free": false,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      }
    },
    //ANALYTICS
    "analytics": {
      "analytics": {
        "free": true,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      },
      "analytics_reports": {
        "free": false,
        "basic": true,
        "pro": true,
        "business": true,
        "school": true
      },
      "pro": {
        "free": false,
        "basic": false,
        "pro": true,
        "business": true,
        "school": true
      },
      "limit_days": {
        "free": 0,
        "basic": 6, //dia actual - 6
        "pro": 29, //dia actual - 29
        "business": -1,
        "school": -1
      }
    },
    //NOTIFICATIONS
    "notification": {
      "notification": {
        "free": false,
        "basic": false,
        "pro": true,
        "business": true,
        "school": true
      }
    }
  }

  checkLimitsByLicense(modul, part) {
    //var type_version = 'business';//this.restaurant.license
    return this.limits[modul][part][this.restaurant.license];
  }

  openLandingPricing() {
    //link a wordpress
    var landing_url = "https://mycheftool.com/tarifas/";
    //
    if (this.so_mobile) {
      window.location.assign(landing_url);
    } else {
      window.open(landing_url, '_blank');
    }
  }

  openPayProMonth() {
    //link a wordpress
    var final_path = this.api_path + "suscription/" + this.user_email + "/stripe/pro/month";
    //
    if (this.so_mobile) {
      window.location.assign(final_path);
    } else {
      window.open(final_path, '_self');
    }
  }

  openPayProMonthBlank() {
    //link a wordpress
    var final_path = this.api_path + "suscription/" + this.user_email + "/stripe/pro/month";
    //
    if (this.so_mobile) {
      window.location.assign(final_path);
    } else {
      window.open(final_path, '_blank');
    }
  }

  openPayProMonthBlankPaypal() {
    //link a wordpress
    var final_path = this.api_path + "suscription/" + this.user_email + "/paypal/pro/month";
    //
    if (this.so_mobile) {
      window.location.assign(final_path);
    } else {
      window.open(final_path, '_blank');
    }
  }

  openPayBusinessMonth() {
    //link a wordpress
    var final_path = this.api_path + "suscription/" + this.user_email + "/stripe/business/month";
    //
    if (this.so_mobile) {
      window.location.assign(final_path);
    } else {
      window.open(final_path, '_self');
    }
  }

  openPayBusinessMonthBlank() {
    //link a wordpress
    var final_path = this.api_path + "suscription/" + this.user_email + "/stripe/business/month";
    //
    if (this.so_mobile) {
      window.location.assign(final_path);
    } else {
      window.open(final_path, '_blank');
    }
  }

  openPayBusinessMonthBlankPaypal() {
    //link a wordpress
    var final_path = this.api_path + "suscription/" + this.user_email + "/paypal/business/month";
    //
    if (this.so_mobile) {
      window.location.assign(final_path);
    } else {
      window.open(final_path, '_blank');
    }
  }

  openPayBasicMonthBlank() {
    //link a wordpress
    var final_path = this.api_path + "suscription/" + this.user_email + "/stripe/basic/month";
    //
    if (this.so_mobile) {
      window.location.assign(final_path);
    } else {
      window.open(final_path, '_blank');
    }
  }

  ifNumEmpty(variable) {
    if (variable) {
      return variable;
    } else {
      return 0;
    }
  }

  cutString(string, length) {
    if (string.length > length) {
      string = string.substring(0, length - 3) + '...';
    } else {//añadir espacios
      while (string.length < length) {
        string = string + ' ';
      }
    }
    return string;
  }

  searchNonUndefinedInObject(obj) {
    for (const key in obj) {
      if (obj[key] === undefined) {
        return false;
      }
    }
    return true;
  }

  getColorsElements() {
    let colors = [
      {
        pos_background_color: "",
        pos_border_color: "",
        name: this.translate.instant('general-sin-color')
      },
      {
        pos_background_color: "rgba(0, 0, 0, 0.2)",
        pos_border_color: "rgba(0, 0, 0, 1)",
        name: this.translate.instant('general-negro')
      },
      {
        pos_background_color: "rgba(4, 51, 255, 0.2)",
        pos_border_color: "rgba(4, 51, 235, 1)",
        name: this.translate.instant('general-azul-oscuro')
      },
      {
        pos_background_color: "rgba(148, 82, 0, 0.2)",
        pos_border_color: "rgba(148, 82, 0, 1)",
        name: this.translate.instant('general-marron-cafe')
      },
      {
        pos_background_color: "rgba(0, 255, 255, 0.2)",
        pos_border_color: "rgba(0, 255, 255, 1)",
        name: this.translate.instant('general-azul-hielo')
      },
      {
        pos_background_color: "rgba(255, 64, 255, 0.2)",
        pos_border_color: "rgba(255, 64, 255, 1)",
        name: this.translate.instant('general-rosado')
      },
      {
        pos_background_color: "rgba(0, 200, 0, 0.2)",
        pos_border_color: "rgba(0, 200, 0, 1)",
        name: this.translate.instant('general-verde')
      },
      {
        pos_background_color: "rgba(255, 147, 0, 0.2)",
        pos_border_color: "rgba(255, 147, 0, 1)",
        name: this.translate.instant('general-naranja')
      },
      {
        pos_background_color: "rgba(148, 33, 148, 0.2)",
        pos_border_color: "rgba(148, 33, 148, 1)",
        name: this.translate.instant('general-lila')
      },
      {
        pos_background_color: "rgba(255, 38, 0, 0.2)",
        pos_border_color: "rgba(255, 38, 0, 1)",
        name: this.translate.instant('general-rojo-sandia')
      },
      {
        pos_background_color: "rgba(255, 220, 0, 0.2)",
        pos_border_color: "rgba(255, 220, 0, 1)",
        name: this.translate.instant('general-amarillo')
      },
      {
        pos_background_color: "rgba(121, 121, 121, 0.2)",
        pos_border_color: "rgba(121, 121, 121, 1)",
        name: this.translate.instant('general-gris')
      },
      {
        pos_background_color: "rgba(0, 145, 147, 0.2)",
        pos_border_color: "rgba(0, 145, 147, 1)",
        name: this.translate.instant('general-verde-oscuro')
      },
      {
        pos_background_color: "rgba(1, 25, 147, 0.2)",
        pos_border_color: "rgba(1, 25, 147, 1)",
        name: this.translate.instant('general-morado')
      },
      {
        pos_background_color: "rgba(146, 144, 0, 0.2)",
        pos_border_color: "rgba(146, 144, 0, 1)",
        name: this.translate.instant('general-verde-kiwi')
      },
      {
        pos_background_color: "rgba(148, 17, 0, 0.2)",
        pos_border_color: "rgba(148, 17, 0, 1)",
        name: this.translate.instant('general-marron-cacao')
      },
      {
        pos_background_color: "rgba(255, 126, 121, 0.2)",
        pos_border_color: "rgba(255, 126, 121, 1)",
        name: this.translate.instant('general-rojo-frambuesa')
      },
    ];
    return colors;
  }

  showIvaProducts(product_list) {
    var _product_list = JSON.parse(JSON.stringify(product_list));
    var _return = [];
    var total = 0;
    var subtotal = 0;
    var total_tax = 0;
    var general_discount = 0;
    var discount_ticket_restaurant = 0;
    var index;

    for (let element of this.objectToArray(_product_list)) {
      if (element.count == undefined || element.count) {
        if (element.type != 'discount' && element.type != 'ticket_discount' && element.type != 'linediscount' && element.type != 'invite') {
          if (element.units == undefined && (element.type_unit == undefined || element.type_unit != 'scale')) {
            element.units = 1
          }
          if (element.tax == undefined) {
            element.tax = this.RESTAURANT_TAX;
          } else {
            element.tax = parseFloat(element.tax);
          }
          var price_variations = 0;
          var price_refund = 0;
          if (element.variation && element.variation.length > 0) {
            for (let variation of element.variation) {
              if (variation.price) {
                if (variation.type == 'refund') {
                  price_refund += parseFloat(variation.price);
                } else {
                  price_variations += parseFloat(variation.price);
                }
              }
            }
          }
          index = _return.findIndex(x => x.tax == element.tax);
          if (index != -1) {
            _return[index].total += (element.price * element.units) + price_variations;
            _return[index].total_without_iva += this.createSubTotal((element.price * element.units) + price_variations, element.tax);
            _return[index].total_refund += price_refund;
          } else {
            _return.push({
              tax: element.tax,
              total: (element.price * element.units) + price_variations,
              total_without_iva: this.createSubTotal((element.price * element.units) + price_variations, element.tax),
              total_refund: price_refund
            });
          }
        } else {
          var name_parts;
          if (element.name.toLowerCase().includes('des.') || element.name.toLowerCase().includes('inv.')) {
            name_parts = element.name.split(' - ');
            var element_to_discount = name_parts[1];
            if (name_parts.length == 4) {//elementos personalizados name = Name - 6
              element_to_discount = name_parts[1] + ' - ' + name_parts[2];
            } else if (name_parts.length == 5) { //elementos personalizados name = Name - 6 - 10
              element_to_discount = name_parts[1] + ' - ' + name_parts[2] + ' - ' + name_parts[3];
            }
            var element_tax = element.tax || this.RESTAURANT_TAX;
            var index_element = this.objectToArray(_product_list).findIndex(x => x.name == element_to_discount && x.tax === element_tax);
            if (index_element != -1) {
              index = _return.findIndex(x => x.tax == _product_list[index_element].tax);
              if (index != -1) {
                _return[index].total += element.price * element.units;
                _return[index].total_without_iva = this.createSubTotal(_return[index].total, _return[index].tax);
              } else {
                _return.push({
                  tax: element.tax,
                  total: element.price * element.units,
                  total_without_iva: this.createSubTotal((element.price * element.units), element.tax),
                  total_refund: 0
                });
              }
            } else {
              index = _return.findIndex(x => x.tax == element_tax);
              if (index != -1) {
                _return[index].total += element.price * element.units;
                _return[index].total_without_iva = this.createSubTotal(_return[index].total, _return[index].tax);
              } else {
                _return.push({
                  tax: element_tax,
                  total: element.price * element.units,
                  total_without_iva: this.createSubTotal((element.price * element.units), element_tax),
                  total_refund: 0
                });
              }
            }
          } else if (element.name.toLowerCase().includes('descuento')) {
            name_parts = element.name.split(' - ');
            general_discount = name_parts[0].replace('%', ' ').split(" ")[1];
          } else if (element.name.toLowerCase().includes('ticket restaurante')) {
            name_parts = element.name.split(' ');
            discount_ticket_restaurant = parseFloat(name_parts[2]);
          }
        }
      }
    }
    _return.forEach((tax) => {
      tax.total = this.roundToTwoDecimals(((tax.total - (tax.total * (general_discount / 100))) - discount_ticket_restaurant) + tax.total_refund);
      tax.total_without_iva = this.roundToTwoDecimals(((tax.total_without_iva - (tax.total_without_iva * (general_discount / 100))) - discount_ticket_restaurant) + tax.total_refund);
      //
      total += tax.total;
      subtotal += this.roundToTwoDecimals(tax.total_without_iva);
    });

    total_tax = this.roundToTwoDecimals(total - subtotal);
    subtotal = this.roundToTwoDecimals(subtotal);
    _return.sort((one, two) => (one.tax < two.tax ? -1 : 1));

    return {
      taxs: _return,
      total: total,
      subtotal: subtotal,
      total_tax: total_tax
    };
  }

  roundToTwoDecimals(number) {
    return Math.round(number * 100) / 100;
  }

  sendToBigqueryRegister(event) {
    const params = new HttpParams()
      .set('data', JSON.stringify({
        event: event,
        business: (this.register_business || this.getBusinessType(this.restaurant.business) || ''),
        stores: (this.register_stores || this.restaurant.plg_register_stores || ''),
        workers: (this.register_workers || this.restaurant.plg_register_workers || ''),
        new_business: (this.register_new_business || this.restaurant.plg_register_new_business || ''),
        is_digital: (this.register_worked_so_far || this.restaurant.plg_register_is_digital || ''),
        buyer_person: (this.register_buyer_person || this.restaurant.buyer_person || ''),
        email: this.user_email,
        address: (this.register_address || this.restaurant.address || ''),
        company: (this.register_company || this.restaurant.company || ''),
        phone: (this.register_phone || this.restaurant.phone || ''),
        contact: (this.register_contact || this.restaurant.name || ''),
        start_by: (this.register_start_by || this.restaurant.register_start_by || ''),
        city: '',
      }));

    this.http.post(this.analytics_path + 'register_send_bigquery', params, {})
      .subscribe(async res => {
      });
  }

  getTrialDays() {
    //Si el restaurante tiene la variable pro_trial_date
    if (this.restaurant.pro_trial_date) {
      const current_day = moment(); //Fecha actual
      const pro_trial_date = moment(this.restaurant.pro_trial_date.toDate()).startOf('day'); //Fecha de inicio del pro_trial_date
      const days_left = current_day.diff(pro_trial_date, 'days'); //La diferencia de dias entre el dia actual y el pro_trial_date
      this.trial_days = (15 - days_left); //Restamos los dias totales de trial, para tener los dias que le quedan al usuario
    }
  }

  replaceSpecialChars(text) {
    return text.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/ /g, '_').replace(/'"/g, "");
  }

  getRestaurantLogoUrl($img_url) {
    if ($img_url != '') {
      $img_url = 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/' + encodeURIComponent($img_url) + '?alt=media';
      return $img_url;
    } else {
      return '';
    }
  }

  ifVarisFiniteOrNaN(result) {
    if (!isFinite(result) || isNaN(result)) {
      return 0;
    } else {
      return result;
    }
  }

  async updateERPNextCustomer() {
    try {
      await this.http.post(this.analytics_path + 'erpnext/customer/update', {
        restaurant_uid: this.restaurant_uid
      }).toPromise();
    } catch (error) { }
  }

  getBusinessType(business) {
    switch (business) {
      case 1:
        return 'Restaurante';
      case 2:
        return 'Bar';
      case 3:
        return 'Catering';
      case 4:
        return 'Hotel';
      case 5:
        return 'Hostel';
      case 6:
        return 'Food Truck';
      case 7:
        return 'Buffet';
      case 8:
        return 'Self-services';
      case 9:
        return 'Fast Food';
      case 10:
        return 'Delivery';
      case 11:
        return 'Escuela / Universidad';
      case 12:
        return 'Granja';
      case 13:
        return 'Otro';
      case 14:
        return 'Ghost/Dark Kitche';
      case 15:
        return 'Chringito - Beach bar';
      default:
        return 'Otro';
    }
  }

  styleHeight(height_mobile: boolean = false) {
    let height = window.innerHeight;
    // Ajustar la altura según las condiciones de prueba y licencia
    height -= (this.trial_days > 0 && this.trial_days <= 15) || (this.trial_days === 0 && this.restaurant.license === 'free')
      ? 91
      : 51;

    // Reducir la altura por el título de la página
    height -= 125;
    // Si es una plataforma móvil y height_mobile es true, se mantiene la altura calculada.
    // Si es una plataforma móvil y height_mobile es false, se establece 'auto'.
    if (this.platform_mobile) {
      return {
        height: height_mobile ? `${height}px` : 'auto'
      };
    }
    // En otros casos, devuelve la altura calculada
    return {
      height: `${height}px`
    };
  }

  async sendIntegrationSlack(integration, msg) {
    var title = integration;
    if (integration === "PAYMENT METHODS") {
      title = "PAYMENT METHODS :moneybag: ";
    } else {
      title = "INTEGRATION: Deliverect";
    }

    var blocks = [
      {
        "type": "section",
        "text": {
          "type": "mrkdwn",
          "text": title
        }
      },
      {
        "type": "section",
        "text": {
          "type": "mrkdwn",
          "text": ":desktop_computer: APP2" +
            "\n :bust_in_silhouette: " + this.restaurant.name +
            "\n :knife_fork_plate: " + this.restaurant.company +
            "\n :email: " + this.restaurant.email +
            "\n :phone: " + this.restaurant.phone.toString() +
            "\n :round_pushpin: " + this.restaurant.address +
            "\n :credit_card: " + this.restaurant.license.toUpperCase() +
            "\n :arrow_right: " + msg + " :arrow_left:"
        }
      },
    ];
    const slack_params = new HttpParams()
      .set('msg', integration)
      .set('blocks', JSON.stringify(blocks))
      .set('channel', '#integracions-mct');

    //send slack
    await this.http.post(this.analytics_path + 'send_slack', slack_params, {})
      .subscribe(async res => { });
    this.launchToast(this.translate.instant('general-enviado-correctamente'), 3000, 'bottom');
  }

  cleanString(regex, inputString, text_transform) {
    // Utilizamos una expresión regular para eliminar caracteres no deseados
    var cleanedString = inputString.replace(regex, '');
    if (text_transform === 'uppercase') {
      return cleanedString.toUpperCase();
    } else if (text_transform === 'lowercase') {
      return cleanedString.toLowerCase();
    } else {
      return cleanedString;
    }
  }

  async createStripeCustomer() {
    const params = new HttpParams()
      .set('company', this.restaurant.company)
      .set('email', this.restaurant.email)
      .set('address_countrycode', this.restaurant.address_countrycode);
    return this.http.post(this.analytics_path + 'stripe/create/customer', params, {}).toPromise();
  }

  async getStripeCustomerPortal() {
    const params = new HttpParams()
      .set('stripe_customer_id', this.restaurant.stripe_customer_id);
    return this.http.post(this.analytics_path + 'stripe/create/customer_portal', params, {}).toPromise();
  }

  getCellClass({ row, column, value }): any {
    return {
      'pl-0': true
    };
  }

  RenameFiles(files, uid_element,) {
    /*let new_files = new DataTransfer();
    for (let i = 0; i < files.length; i++) {
      let split = files[i].type.split('/')[1];
      let UniqueFileName = `${this.restaurant_uid}_${uid_element}_${Date.now()}_${i}.${split}`
      let newFile = new File([files[i]], UniqueFileName, { type: files[i].type, lastModified: files[i].lastModified });
      new_files.items.add(newFile);
    }*/
    return files;
  }

  //funcion que combina arrays de taxs
  combineArraysByTax(arrays, rectification = false) {
    const taxTotals = {};

    arrays.forEach(array => {
      array.forEach(obj => {
        const tax = obj.tax;
        const multiplier = rectification ? -1 : 1;

        if (taxTotals.hasOwnProperty(tax)) {
          // Si existe, agregar los totales al objeto existente
          // Mantener el signo original de los valores negativos
          const total = obj.total < 0 ? obj.total : obj.total * multiplier;
          const total_without_iva = obj.total_without_iva < 0 ? obj.total_without_iva : obj.total_without_iva * multiplier;
          const total_refund = obj.total_refund < 0 ? obj.total_refund : obj.total_refund * multiplier;

          taxTotals[tax].total = (taxTotals[tax].total || 0) + total;
          taxTotals[tax].total_without_iva = (taxTotals[tax].total_without_iva || 0) + total_without_iva;
          taxTotals[tax].total_refund = (taxTotals[tax].total_refund || 0) + total_refund;
        } else {
          // Si no existe, crear una nueva entrada
          // Mantener el signo original de los valores negativos
          const total = obj.total < 0 ? obj.total : obj.total * multiplier;
          const total_without_iva = obj.total_without_iva < 0 ? obj.total_without_iva : obj.total_without_iva * multiplier;
          const total_refund = obj.total_refund < 0 ? obj.total_refund : obj.total_refund * multiplier;

          taxTotals[tax] = {
            tax: tax,
            total: total,
            total_without_iva: total_without_iva,
            total_refund: total_refund
          };
        }
      });
    });
    const combinedArray = this.objectToArray(taxTotals);
    return combinedArray;
  }

  isElementDiscount(element_type) {
    if (['discount', 'linediscount', 'invite', 'restaurant_ticket'].indexOf(element_type) !== -1) {
      return true;
    }
    return false;
  }

  getOldRolFromNew(user_access) {
    var found = user_access.find(item => item === 'admin');
    if (found) {
      return found;
    } else {
      return 'general';
    }
  }

  getCuisineType(value) {
    switch (value) {
      case "9":
        return "Arrocería";
      case "11":
        return "Asiática";
      case "5":
        return "Americana";
      case "10":
        return "Asador / barbacoa";
      case "15":
        return "Bar de Tapas";
      case "19":
        return "Bocadillos-Sandwiches";
      case "25":
        return "Caribeña";
      case "33":
        return "Colombiana";
      case "36":
        return "Creativa";
      case "40":
        return "De mercado";
      case "42":
        return "De Fusión";
      case "48":
        return "Española";
      case "58":
        return "Hamburguesería";
      case "69":
        return "Italiana";
      case "70":
        return "Japonesa";
      case "78":
        return "Marisquería";
      case "81":
        return "Mediterránea";
      case "82":
        return "Mexicana";
      case "92":
        return "Pizzería";
      case "103":
        return "Street food / Comida callejera";
      case "106":
        return "Sushi";
      case "111":
        return "Tradicional";
      case "116":
        return "Vegetariana";
      case "1":
        return "Afgana";
      case "2":
        return "Africana";
      case "3":
        return "Albanesa";
      case "4":
        return "Alemana";
      case "6":
        return "Árabe";
      case "7":
        return "Argentina";
      case "8":
        return "Armenia";
      case "12":
        return "Australiana";
      case "13":
        return "Austríaca";
      case "14":
        return "Bangladesí";
      case "16":
        return "Belga";
      case "17":
        return "Biológica";
      case "18":
        return "Birmana";
      case "20":
        return "Brasileña";
      case "21":
        return "Británica";
      case "22":
        return "Cajún y criolla";
      case "23":
        return "Camboyana";
      case "24":
        return "Canadiense";
      case "26":
        return "Caucásica";
      case "27":
        return "Centroamericana";
      case "28":
        return "Centroeuropea";
      case "29":
        return "Checa";
      case "30":
        return "Chilena";
      case "31":
        return "China";
      case "32":
        return "Crudivegana";
      case "34":
        return "Contemporánea";
      case "35":
        return "Coreana";
      case "37":
        return "Croata";
      case "38":
        return "Cubana";
      case "39":
        return "Danesa";
      case "41":
        return "Delicatessen";
      case "43":
        return "Ecuatoriana";
      case "44":
        return "Egipcia";
      case "45":
        return "Erótica";
      case "46":
        return "Escandinava";
      case "47":
        return "Escocesa";
      case "49":
        return "Etíope";
      case "50":
        return "Europea";
      case "51":
        return "Europa del Este";
      case "52":
        return "Filipina";
      case "53":
        return "Francesa";
      case "54":
        return "Fusión";
      case "55":
        return "Georgiana";
      case "56":
        return "Griega";
      case "57":
        return "Guatemalteca";
      case "59":
        return "Hawaiana";
      case "60":
        return "Holandesa";
      case "61":
        return "Húngara";
      case "62":
        return "India";
      case "63":
        return "Indonesia";
      case "64":
        return "Inglesa";
      case "65":
        return "Internacional";
      case "66":
        return "Iraní";
      case "67":
        return "Irlandesa";
      case "68":
        return "Israelí";
      case "71":
        return "Jamaicana";
      case "72":
        return "Kebab";
      case "73":
        return "Latina";
      case "74":
        return "Latviana";
      case "75":
        return "Libanesa";
      case "76":
        return "Macrobiótica";
      case "77":
        return "Marinera";
      case "79":
        return "Marroquí";
      case "80":
        return "Malaya";
      case "83":
        return "Mongola";
      case "84":
        return "Neozelandesa";
      case "85":
        return "Nepalí";
      case "86":
        return "Nikkei";
      case "87":
        return "Noruega";
      case "88":
        return "Oriente Medio";
      case "89":
        return "Pakistaní";
      case "90":
        return "Peruana";
      case "91":
        return "Persa";
      case "93":
        return "Polaca";
      case "94":
        return "Polinesia";
      case "95":
        return "Portuguesa";
      case "96":
        return "Puertorriqueña";
      case "97":
        return "Rumana";
      case "98":
        return "Rusa";
      case "99":
        return "Saludable";
      case "100":
        return "Salvadoreña";
      case "101":
        return "Singapureña";
      case "102":
        return "Sueca";
      case "104":
        return "Sudamericana";
      case "105":
        return "Suiza";
      case "107":
        return "Tailandesa";
      case "108":
        return "Taiwanesa";
      case "109":
        return "Tex-Mex";
      case "110":
        return "Tibetana";
      case "112":
        return "Tunecina";
      case "113":
        return "Turca";
      case "114":
        return "Ucraniana";
      case "115":
        return "Uzbeka";
      case "117":
        return "Venezolana";
      case "118":
        return "Vietnamita";
      default:
        return "Unknown cuisine";
    }
  }

  getPaymentMethodInex(paymentMethod) {
    switch (paymentMethod) {
      case 'giro':
        return this.translate.instant('income-expenses-giro');
      case 'efectivo':
        return this.translate.instant('general-efectivo');
      case 'tarjeta':
        return this.translate.instant('general-tarjeta');
      case 'bancaria':
        return this.translate.instant('income-expenses-trans-bancaria');
      case 'talon':
        return this.translate.instant('income-expenses-talon');
      case 'abono':
        return this.translate.instant('income-expenses-abono');
      case 'otro':
        return this.translate.instant('income-expenses-otro');
      default:
        return '';
    }
  }

  async sendCustomerMctSlack(title, section) {
    try {
      var blocks = [
        {
          "type": "section",
          "text": {
            "type": "mrkdwn",
            "text": title
          }
        },
        section
      ];
      const slack_params = new HttpParams()
        .set('msg', title)
        .set('blocks', JSON.stringify(blocks))
        .set('channel', '#customers-mct');

      //send slack
      await this.http.post(this.analytics_path + 'send_slack', slack_params, {}).subscribe(async res => { });
    } catch (error) { }
  }

  async sendSlack(title, section, channel) {
    try {
      var blocks = [
        {
          "type": "section",
          "text": {
            "type": "mrkdwn",
            "text": title
          }
        },
        section
      ];
      const slack_params = new HttpParams()
        .set('msg', title)
        .set('blocks', JSON.stringify(blocks))
        .set('channel', channel);

      //send slack
      await this.http.post(this.analytics_path + 'send_slack', slack_params, {}).subscribe(async res => { });
    } catch (error) { }
  }

  async getNoProvider() {
    const providerRef = this.firestore.collection('providers');
    await providerRef
      .where('UID_RESTAURANT', '==', this.restaurant_uid)
      .where('no_provider', '==', true)
      .get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          var provider = doc.data();
          provider.UID = doc.id;
          this.no_provider = provider;
        });
      });
  }

  private conversionFactors: Record<Unit, Record<Unit, number>> = {
    kg: { kg: 1, g: 1000, l: 1, ml: 1000 },
    g: { kg: 0.001, g: 1, l: 0.001, ml: 1 },
    l: { kg: 1, g: 1000, l: 1, ml: 1000 },
    ml: { kg: 0.001, g: 1, l: 0.001, ml: 1 },
  };

  convert(value: number, fromUnit: Unit, toUnit: Unit): number {
    if (!(fromUnit in this.conversionFactors) || !(toUnit in this.conversionFactors[fromUnit])) {
      throw new Error(`Conversión no soportada de ${fromUnit} a ${toUnit}`);
    }
    return value * this.conversionFactors[fromUnit][toUnit];
  }

  autoConvertQuantity(value: number, unit: Unit): ConvertedQuantity {
    if (unit === "g" && value >= 1000) {
      return { value: value / 1000, unit: "kg" };
    } else if (unit === "kg" && value < 1) {
      return { value: value * 1000, unit: "g" };
    } else if (unit === "ml" && value >= 1000) {
      return { value: value / 1000, unit: "l" };
    } else if (unit === "l" && value < 1) {
      return { value: value * 1000, unit: "ml" };
    }
    return { value, unit };
  }

  getLanguageName(langCode: string): string {
    const languageMap = {
      'es': this.translate.instant('config-establishment-create-espanol'),
      'ca': this.translate.instant('config-establishment-create-catala'),
      'en': this.translate.instant('config-establishment-create-ingles'),
      'fr': this.translate.instant('config-establishment-create-frances'),
      'de': this.translate.instant('config-establishment-create-aleman'),
      'it': this.translate.instant('config-establishment-create-italiano')
    };
    return languageMap[langCode] || langCode.toUpperCase();
  }

  getMovementType(value) {
    var _return = '';
    if (value.includes('pay')) {
      _return = this.translate.instant('general-metodo-pago') + ': ' + this.returnPaymentType(value.substring(4));
    } else {
      switch (value) {
        case 'add element':
          _return = this.translate.instant('ticket-log-add-element');
          break;
        case 'delete element':
          _return = this.translate.instant('ticket-log-delete-element');
          break;
        case 'tips':
          _return = this.translate.instant('ticket-log-tips');
          break;
        case 'pay card':
          _return = this.translate.instant('ticket-log-pay-card');
          break;
        case 'pay cash':
          _return = this.translate.instant('ticket-log-pay-cash');
          break;
        case 'print ticket':
          _return = this.translate.instant('ticket-log-print-ticket');
          break;
        case 'send order':
          _return = this.translate.instant('ticket-log-send-order');
          break;
        case 'change customer':
          _return = this.translate.instant('ticket-log-change-customer');
          break;
        case 'change number of customers':
          _return = this.translate.instant('ticket-log-change-number-of-customers');
          break;
        case 'discount':
          _return = this.translate.instant('ticket-log-discount');
          break;
        case 'switch cash':
          _return = this.translate.instant('ticket-log-switch-cash');
          break;
        case 'move to another table':
          _return = this.translate.instant('ticket-log-move-to-another-table');
          break;
        case 'create invoice':
          _return = this.translate.instant('ticket-log-create-invoice');
          break;
        case 'save invoice':
          _return = this.translate.instant('ticket-log-save-invoice');
          break;
        case 'delete order':
          _return = this.translate.instant('ticket-log-delete-order');
          break;
        case 'change status':
          _return = this.translate.instant('ticket-log-change-status');
          break;
        case 'print bank':
          _return = this.translate.instant('ticket-log-imprimir-recibo-banco');
          break;
        case 'delete order elements':
          _return = this.translate.instant('ticket-log-delete-element');
          break;
        case 'refund ticket':
          _return = this.translate.instant('general-refund');
          break;
        case 'cancel ticket':
          _return = this.translate.instant('ticket-log-ticket-cancelado');
          break;
        case 'print proforma':
          _return = this.translate.instant('general-imprimir-proforma');
          break;
        case 'cash delivered':
          _return = this.translate.instant('general-efectivo-entregado');
          break;
        case 'cash change':
          _return = this.translate.instant('general-efectivo-devuelto');
          break;
        case 'import sales':
          _return = this.translate.instant('general-importar-ventas');
          break;
        case 'cancel overwrite':
          _return = this.translate.instant('general-cancelar-sobreescribir');
          break;
        case 'overwrite':
          _return = this.translate.instant('general-sobreescribir');
          break;
        case 'cash drawer':
          _return = this.translate.instant('general-cajon');
          break;
        default:
          _return = value;
      }
    }
    return _return;
  }


}


// WEBPACK FOOTER //
// ./src/globals.ts